import { Drawer, Tabs, Form, DatePicker, Button, Select, Table, Modal, Tooltip, message, Spin, Checkbox, Divider, Input } from "antd";
import React, { Component } from "react";
import {
	getHospitalListGroups,
	getConsultationApplyHospitalGroup,
	getConsultationTotal,
	getApplyHospitalConsultation,
	getSearchDoctorList,
	getDoctorWorkload,
	getExportDoctorWorkload,
	getExportConsultationVolume,
	getBillDoctorWorkload,
	getBillingHospitalList,
	getBillingDoctorList,
	getExportBillDoctorWorkload,
	getTypicalCasesBaseInfo,
	getExamItem,
	GetTableHeaderData,
	getSearchPartSecondData,
	getGroupExamSubList,
	getGroupExamItemList,
	getSearchPartFirstData,

} from "@/request/api";
import moment from "moment";
import "./statisticsTable.scss";
import QueryLeft from "../../components/queryLeft";
import PaintStatisticsTable from "./PaintStatisticsTable";
import { getFirstGroupList, uniqueJsonArrByField, fixedTotal, requestErrorLog } from '@/common/util'
import { exportExcelByData } from '@/common/XLSX'
const { TabPane } = Tabs;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
export class StatisticsTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showKey: "1",
			startValue: moment(),
			startOpen: false,
			endValue: moment(),
			endOpen: false,
			billValue: moment(), // 开单医生查询年度
			billOpen: false,
			consultHospitalList: [],
			applyHospitalList: [],
			billApplyHospitalList: [], //开单医生医院列表
			billDoctorList: [], //开单医生列表
			doctorList: [],
			doctorValue: "",
			billDoctorValue: "", // 开单医生
			selectdoctorName: "",
			selectBillDoctorName: "",
			consultHospitalValue: "",
			billHospitalCode: "",
			consultHospitalName: "",
			billHospitalName: "", //隶属机构名称
			billApplyHospitalName: "",
			selectStartValue: "",
			applyHospitalValue: "",
			applyHospitalName: "",
			dataList: [],
			doctorWorkList: [],
			billDoctorWorkList: [],
			statisticalType: "",
			monthList: [
				{ key: "01", value: "一月" },
				{ key: "02", value: "二月" },
				{ key: "03", value: "三月" },
				{ key: "04", value: "四月" },
				{ key: "05", value: "五月" },
				{ key: "06", value: "六月" },
				{ key: "07", value: "七月" },
				{ key: "08", value: "八月" },
				{ key: "09", value: "九月" },
				{ key: "10", value: "十月" },
				{ key: "11", value: "十一月" },
				{ key: "12", value: "十二月" },
			],
			consultationMonth: "",
			selectConsultationMonth: "",
			consultationMonthDisabled: false,
			doctorMonth: "",
			selectDoctorMonth: "",
			doctorMonthDisabled: false,
			billMonth: "",
			selectBillMonth: "",
			billMonthDisabled: false,
			paintModalShow: false,
			consultationStatus: [],
			reportStatus: [],
			allData: [],
			checkType: [],
			checkSubclass: [],
			checkProject: [],
			institutionOrPerson: 0,//0：机构，1：个人
			searchTime: '',
			packageHospitalData: [],//套餐检查量机构列表
			packagePersonData: [],//套餐检查量医生列表
			startDate: moment().startOf('month'),
			endDate: moment().endOf("day"),
			firstGroupList: [],//一级分组列表
			secondGroupList: [],//一级分组列表
			firstGroupValue: [],
			secondGroupValue: [],
			firstGroupName: '',
			secondGroupName: '',
			isStystemOrSupervise: localStorage.getItem("statisticalType") === '监管机构' || JSON.parse(localStorage.getItem("userInfo")).HOSPITAL_CODE === "PLATFORM",//判断当前用户是监管机构或者平台管理账号
			userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
			isLoading: false,
			isExportLoading: false,
			isChangeconsultHospitalNameOrList: false,//记录会诊医院选项和列表发生变化时，需要重新请求一下套餐检查量数据


			firstGroupListBill: [],//开单量一级分组列表
			secondGroupListBill: [],//开单量一级分组列表
			firstGroupValueBill: [],
			secondGroupValueBill: [],
			firstGroupNameBill: '',
			secondGroupNameBill: '',
			isFixedHeJiHuiZhen: false,
			isFixedHeJiYiSheng: false,
			isFixedHeJiKaiDan: false,
			isFixedHeJiTaoCan: false,

			examSearchType: [
				{ label: "申请病例量", value: 0 },
				{ label: "会诊病例量", value: 1 },
				{ label: "退回病例量", value: 2 },
			],

			checkSearchType: [
				{ label: "动态心电", value: 0 },
				{ label: "动态血压", value: 1 },
				{ label: "静息心电", value: 2 },
			],
			examSearchTypeValue: [0, 1, 2],
			checkSearchTypeValue: [0, 1, 2],

			columns: [
				{
					title: "",
					ellipsis: true,
					fixed: 'left',
					children: [
						{
							title: "一级分组",
							dataIndex: "FIRST_GROUP_NAME",
							key: "FIRST_GROUP_NAME",
							width: '120px',
							align: "left",
							fixed: 'left',
							onCell: () => {
								return {
									style: {
										maxWidth: '100px',
										overflow: 'hidden',
										whiteSpace: 'nowrap',
										textOverflow: 'ellipsis',
										cursor: 'pointer'
									}
								}
							},
							render: (text) => {
								return <span>
									<Tooltip title={text}>
										{text}
									</Tooltip>
								</span>;
							},

						},
					],
				},
				{
					title: "",
					ellipsis: true,
					fixed: 'left',
					children: [
						{
							title: "二级分组",
							dataIndex: "SECOND_GROUP_NAME",
							key: "SECOND_GROUP_NAME",
							align: "left",
							fixed: 'left',
							width: '240px',
							onCell: () => {
								return {
									style: {
										maxWidth: '220px',
										overflow: 'hidden',
										whiteSpace: 'nowrap',
										textOverflow: 'ellipsis',
										cursor: 'pointer'
									}
								}
							},
							render: (text) => {
								return <span>
									<Tooltip title={text}>
										{text}
									</Tooltip>
								</span>;
							},
						},
					],
				},
				{
					title: "",
					ellipsis: true,
					fixed: 'left',
					children: [
						{
							title: "申请机构名称",
							dataIndex: "APPLY_HOSPITAL_NAME",
							key: "APPLY_HOSPITAL_NAME",
							width: '320px',
							align: "left",
							fixed: 'left',
							onCell: () => {
								return {
									style: {
										maxWidth: '300px',
										overflow: 'hidden',
										whiteSpace: 'nowrap',
										textOverflow: 'ellipsis',
										cursor: 'pointer'
									}
								}
							},
							render: (text) => {
								return <span>
									<Tooltip title={text}>
										{text}
									</Tooltip>
								</span>;
							},
						},
					],
				},
				{
					title: "申请病例量",
					ellipsis: true,
					children: [
						{
							title: "动态心电",
							dataIndex: "HOLTER_APPLY",
							key: "HOLTER_APPLY",
							align: "center",
							ellipsis: true,
							width: 100,
						},
						{
							title: "动态血压",
							dataIndex: "BP_APPLY",
							key: "BP_APPLY",
							align: "center",
							ellipsis: true,
							width: 100,
						},
						{
							title: "静息心电",
							dataIndex: "ECG_APPLY",
							key: "ECG_APPLY",
							align: "center",
							ellipsis: true,
							width: 100,
						},
						{
							title: "合计",
							dataIndex: "APPLY_Total",
							key: "APPLY_Total",
							align: "center",
							ellipsis: true,
							width: 100,
						},
					],
				},
				{
					title: "会诊病例量",
					children: [
						{
							title: "动态心电",
							dataIndex: "HOLTER_Consulation_Sum",
							key: "HOLTER_Consulation_Sum",
							align: "center",
							ellipsis: true,
							width: 100,
						},
						{
							title: "动态血压",
							dataIndex: "BP_Consulation_Sum",
							key: "BP_Consulation_Sum",
							align: "center",
							ellipsis: true,
							width: 100,
						},
						{
							title: "静息心电",
							dataIndex: "ECG_Consulation_Sum",
							key: "ECG_Consulation_Sum",
							align: "center",
							ellipsis: true,
							width: 100,
						},
						{
							title: "合计",
							dataIndex: "Consulation_Total",
							key: "Consulation_Total",
							align: "center",
							ellipsis: true,
							width: 100,
						},
					],
				},
				{
					title: "退回病例量",
					children: [
						{
							title: "动态心电",
							dataIndex: "HOLTER_Exit_Sum",
							key: "HOLTER_Exit_Sum",
							align: "center",
							ellipsis: true,
							width: 100,
						},
						{
							title: "动态血压",
							dataIndex: "BP_Exit_Sum",
							key: "BP_Exit_Sum",
							align: "center",
							ellipsis: true,
							width: 100,
						},
						{
							title: "静息心电",
							dataIndex: "ECG_Exit_Sum",
							key: "ECG_Exit_Sum",
							align: "center",
							ellipsis: true,
							width: 100,
						},
						{
							title: "合计",
							dataIndex: "Exit_Total",
							key: "Exit_Total",
							align: "center",
							ellipsis: true,
							width: 100,
						},
					],
				},
			],
			drawerShow: false,
			hospitalAdditional: [],
			rightClickRecord: {},
			defauleTableWidth: '1740px',

			selectFirstAllState: false,
			indeterminateFirst: false,
			selectSecondAllState: false,
			indeterminateSecond: false,

			selectFirstAllStateBill: false,
			indeterminateFirstBill: false,
			selectSecondAllStateBill: false,
			indeterminateSecondBill: false,
			isLoadingBill: false,
			isLoadingExportBill: false,

			isLoadingDoctor: false,
			isLoadingExportDoctor: false,
			isLoadingData: false,
			isLoadingExportData: false,

		};
	}
	//tab切换
	handleTabKey = (e) => {
		let dataList = []
		this.setState(
			{
				showKey: e,
				examSearchTypeValue: [0, 1, 2],
				checkSearchTypeValue: [0, 1, 2],
				dataList
			}, () => {
				if (this.state.showKey === "1") {
					let columns = this.changeTableColumns()
					this.setState({
						columns,
					}, () => {
						this.getDataList();
					})
				} else if (this.state.showKey === "2") {
					this.getDoctorWorkload();
				} else if (this.state.showKey === "3") {
					this.getBillDoctorWorkload(); //开单量查询
				} else if (this.state.showKey === '4') {
					//一级分组、二级分组、会诊机构选项、会诊列表、申请机构选项发生变化，进入套餐检查量时，重新获取列表，否则不用
					if (this.state.isChangeconsultHospitalNameOrList === true) {
						this.setState({ isChangeconsultHospitalNameOrList: false }, () => {
							this.searchData();
						})
					}
				}
			}
		);
	};
	//弹出日历和关闭日历的回调
	handleStartOpenChange = (open) => {
		if (open) {
			this.setState({ startOpen: true });
		} else {
			this.setState({ startOpen: false });
		}
	};
	//日历面板切换的回调
	handleStartPanelChange = (value) => {
		this.setState({
			startValue: value,
			startOpen: false,
		});
	};
	async componentDidMount() {
		//获取当前登录人所在分组
		const { userInfo, isStystemOrSupervise } = this.state
		let firstGroupList = await getFirstGroupList();
		//开单量统计分组单独处理
		let resBill = await getSearchPartFirstData('E00113', this.state.userInfo.HOSPITAL_CODE);
		let firstGroupListBill = []
		if (resBill && resBill.Status === 1) {
			firstGroupListBill = resBill.Result ? resBill.Result : []
		} else {
			requestErrorLog('', '综合查询-统计报表-获取开单量一级分组报错', 0, true)
		}
		//二次需求：一级分组为空也请求二级分组列表；单独处理开单量统计分组二
		let secondGroupListBill = []
		let firstArrBill = firstGroupListBill.map(obj => obj.FIRST_GROUP_CODE)
		let firstArrRes = await getSearchPartSecondData("E00113", 'PLATFORM', firstArrBill.toString())
		if (firstArrRes && firstArrRes.Status === 1) {
			secondGroupListBill = firstArrRes.Result ? firstArrRes.Result : []
			secondGroupListBill = uniqueJsonArrByField(secondGroupListBill, 'SECOND_GROUP_NAME')
		} else {
			requestErrorLog('', '综合查询-统计报表-获取一级分组报错', 0, true)
		}
		let stateObject = {
			consultHospitalValue: isStystemOrSupervise ? "" : userInfo.HOSPITAL_CODE,
			consultHospitalName: isStystemOrSupervise ? "" : userInfo.HOSPITAL_NAME,
			billHospitalCode: isStystemOrSupervise ? "" : userInfo.HOSPITAL_CODE,
			billHospitalName: isStystemOrSupervise ? "" : userInfo.HOSPITAL_NAME,
			firstGroupList,
			firstGroupListBill,
			secondGroupListBill,
			isLoadingData: true,
		}
		//二次需求：一级分组为空也请求二级分组列表
		let FIRST_GROUP_CODE
		//如果需要获取所以分组一、分组二，用来取会诊医院列表数据（套餐统计量需要）
		FIRST_GROUP_CODE = firstGroupList.map(obj => obj.FIRST_GROUP_CODE)
		let secondGroupList = await this.getSearchPartSecondData(FIRST_GROUP_CODE)
		let secondGroupListUnRepeat = uniqueJsonArrByField(secondGroupList, 'SECOND_GROUP_NAME')
		stateObject.secondGroupList = secondGroupListUnRepeat

		if (!isStystemOrSupervise) {
			stateObject.consultHospitalList = localStorage.getItem("statisticalType") === '申请医院' ? [] : [{
				HOSPITAL_CODE: this.state.userInfo.HOSPITAL_CODE,
				HOSPITAL_NAME: this.state.userInfo.HOSPITAL_NAME
			}];
			stateObject.billApplyHospitalList = localStorage.getItem("statisticalType") === '申请医院' ? [{
				APPLY_HOSPITAL_CODE: this.state.userInfo.HOSPITAL_CODE,
				APPLY_HOSPITAL_NAME: this.state.userInfo.HOSPITAL_NAME
			}] : [];
		}
		this.setState(stateObject, () => {
			//获取基础数据
			this.allBasicData()
			//获取会诊量统计列表
			this.getConsultDataList();
			//获取套餐检查量数据统计（目的是因为套餐检查量统计的数据查询慢，所以在第一个标签的时候已经开始请求）
			this.searchData();

		}
		);
		const tableDIV = document.getElementById('tableDIV');
		if (tableDIV) {
			tableDIV.oncontextmenu = function (e) {
				// 阻止鼠标默认事件
				e.preventDefault();
			}
		}
	}
	// 会诊医院列表
	initConsultHospitalList = async (FIRST_GROUP_CODE, SECOND_GROUP_CODE) => {
		FIRST_GROUP_CODE = FIRST_GROUP_CODE.toString()
		SECOND_GROUP_CODE = SECOND_GROUP_CODE.toString()
		let Param = {
			Type: "HospitalListGroup",
			FIRST_GROUP_CODE,//一级分组
			SECOND_GROUP_CODE,//二级分组
		};
		let res = await getHospitalListGroups(Param);
		if (res && res.Status === 1) {
			return res.Result ? res.Result : []
		} else {
			requestErrorLog('', '综合查询-统计报表-获取会诊医院列表报错', 0, true)
			return []
		}
	};
	//申请医院列表
	initApplyHostpitalList = async (code, FIRST_GROUP_CODE, SECOND_GROUP_CODE) => {
		FIRST_GROUP_CODE = FIRST_GROUP_CODE.toString()
		SECOND_GROUP_CODE = SECOND_GROUP_CODE.toString()
		code = code ? code : "";
		let Param = {
			Type: "GetAllApplyHospitalGroup",
			HOSPITAL_CODE: code,
			FIRST_GROUP_CODE,//一级分组
			SECOND_GROUP_CODE,//二级分组

		};

		let res = await getConsultationApplyHospitalGroup(Param);
		if (res && res.Status === 1) {
			return res.Result ? res.Result : []
		} else {
			requestErrorLog('', '综合查询-统计报表-获取申请医院列表报错', 0, true)
			return []
		}
	};
	//开单统计医院列表
	initBillHospitalList = async (FIRST_GROUP_CODE, SECOND_GROUP_CODE) => {
		FIRST_GROUP_CODE = FIRST_GROUP_CODE.toString()
		SECOND_GROUP_CODE = SECOND_GROUP_CODE.toString()
		let params = {
			Type: "GetBillingHospitalList",
			QUERY_YEAR: moment(this.state.billValue).format("YYYY"),
			FIRST_GROUP_CODE,//一级分组
			SECOND_GROUP_CODE,//二级分组

		};
		let res = await getBillingHospitalList(params);
		if (res && res.Status === 1) {
			return res.Result ? res.Result : []
		} else {
			requestErrorLog('', '综合查询-统计报表-获取开单统计医院列表报错', 0, true)
			return []
		}
	};

	//开单医生列表
	initBillDoctorList = (code) => {
		let params = {
			Type: "GetBillingDoctorList",
			QUERY_YEAR: moment(this.state.billValue).format("YYYY"),
			HOSPITAL_CODE: code || "",
		};
		getBillingDoctorList(params).then((res) => {
			if (res && res.Status === 1) {
				this.setState({
					billDoctorList: res.Result,
				});
			} else {
				requestErrorLog('', '综合查询-统计报表-获取开单医生列表报错', 0, true)
			}
		});
	};
	//会诊医院发生改变时
	consultHospitalChange = async (code) => {
		//取申请机构得列表
		let applyHospitalList = []
		if (code !== '') {
			applyHospitalList = await this.initApplyHostpitalList(code, this.state.firstGroupValue, this.state.secondGroupValue);
		}
		let doctorList = await this.initDoctorList(code, this.state.firstGroupValue, this.state.secondGroupValue);//会诊人列表数据
		this.setState({
			consultHospitalValue: code,//会诊机构下拉框清空
			applyHospitalValue: '',//申请机构下拉框清空
			doctorValue: '',//会诊人下拉框清空
			applyHospitalList,//申请医院列表清空
			doctorList,
			isChangeconsultHospitalNameOrList: true,
			consultationMonthDisabled: false,
			doctorMonthDisabled: false,
		})

	};
	//申请机构改变
	applyHospitalChange = (code) => {
		let consultationMonthDisabled = false;
		let { consultationMonth, } = this.state;
		if (code !== "") {
			consultationMonthDisabled = true;
			consultationMonth = "";
		}
		this.setState({
			applyHospitalValue: code,
			consultationMonthDisabled,
			consultationMonth,
			isChangeconsultHospitalNameOrList: true,
		});
	};
	//会诊量统计查询事件
	getDataList = () => {
		//只要查询就重新渲染会诊量统计list
		this.setState({
			dataList: [],//因为固定列，导致表格样式错乱，所以每次重新请求要重新渲染
			isLoadingData: true,
		}, () => {
			//改变表格表头
			let columns = this.changeTableColumns()
			if (this.state.applyHospitalValue) {//选择申请医院
				this.getApplyHospitalConsultation();
				this.setState({
					columns,
				})
			} else {//未选择选择申请医院
				this.getConsultDataList();
				this.setState({
					columns,
				})
			}
		})
	};
	//改变会诊量统计查询表格表头
	changeTableColumns = () => {
		let { columns, examSearchTypeValue, checkSearchTypeValue } = this.state;
		let tableWidth = 0
		if (this.state.applyHospitalValue) {
			columns = [
				{
					title: "",
					children: [
						{
							title: "月份",
							dataIndex: "APPLY_HOSPITAL_NAME",
							key: "APPLY_HOSPITAL_NAME",
							width: '120px',
							align: "center",
						},
					],
				},
			]
			tableWidth += 120
		} else {
			if (examSearchTypeValue.length === 3 && checkSearchTypeValue.length === 3) {//全选固定列否则不固定
				columns = [
					{
						title: "",
						ellipsis: true,
						fixed: 'left',
						children: [
							{
								title: "一级分组",
								dataIndex: "FIRST_GROUP_NAME",
								key: "FIRST_GROUP_NAME",
								width: '120px',
								align: "left",
								fixed: 'left',
								onCell: () => {
									return {
										style: {
											maxWidth: '100px',
											overflow: 'hidden',
											whiteSpace: 'nowrap',
											textOverflow: 'ellipsis',
											cursor: 'pointer'
										}
									}
								},
								render: (text) => {
									return <span>
										<Tooltip title={text}>
											{text}
										</Tooltip>
									</span>;
								},

							},
						],
					},
					{
						title: "",
						fixed: 'left',
						children: [
							{
								title: "二级分组",
								dataIndex: "SECOND_GROUP_NAME",
								key: "SECOND_GROUP_NAME",
								width: '240px',
								align: "left",
								fixed: 'left',
								onCell: () => {
									return {
										style: {
											maxWidth: '220px',
											overflow: 'hidden',
											whiteSpace: 'nowrap',
											textOverflow: 'ellipsis',
											cursor: 'pointer'
										}
									}
								},
								render: (text) => {
									return <span>
										<Tooltip title={text}>
											{text}
										</Tooltip>
									</span>;
								},
							},
						],
					},
					{
						title: "",
						fixed: 'left',
						children: [
							{
								title: "申请机构名称",
								dataIndex: "APPLY_HOSPITAL_NAME",
								fixed: 'left',
								key: "APPLY_HOSPITAL_NAME",
								align: "left",
								width: '320px',
								onCell: () => {
									return {
										style: {
											maxWidth: '300px',
											overflow: 'hidden',
											whiteSpace: 'nowrap',
											textOverflow: 'ellipsis',
											cursor: 'pointer'
										}
									}
								},
								render: (text) => {
									return <span>
										<Tooltip title={text}>
											{text}
										</Tooltip>
									</span>;
								},
							},
						],
					},
				]
			} else {
				columns = [
					{
						title: "",
						ellipsis: true,
						children: [
							{
								title: "一级分组",
								dataIndex: "FIRST_GROUP_NAME",
								key: "FIRST_GROUP_NAME",
								width: '120px',
								align: "left",
								ellipsis: true,

							},
						],
					},
					{
						title: "",
						children: [
							{
								title: "二级分组",
								dataIndex: "SECOND_GROUP_NAME",
								key: "SECOND_GROUP_NAME",
								width: '240px',
								align: "left",
								ellipsis: true,
							},
						],
					},
					{
						title: "",
						children: [
							{
								title: "申请机构名称",
								dataIndex: "APPLY_HOSPITAL_NAME",
								key: "APPLY_HOSPITAL_NAME",
								align: "left",
								width: '320px',
								ellipsis: true,
							},
						],
					},
				]
			}
			tableWidth += 680
		}
		if (examSearchTypeValue.includes(0)) {
			if (checkSearchTypeValue.length > 0) {
				let obj = this.checkTypeBack(0, checkSearchTypeValue)
				tableWidth += obj.children.length * 100
				columns.push(obj)
			}
		}
		if (examSearchTypeValue.includes(1)) {
			if (checkSearchTypeValue.length > 0) {
				let obj = this.checkTypeBack(1, checkSearchTypeValue)
				tableWidth += obj.children.length * 100
				columns.push(obj)
			}
		}
		if (examSearchTypeValue.includes(2)) {
			if (checkSearchTypeValue.length > 0) {
				let obj = this.checkTypeBack(2, checkSearchTypeValue)
				tableWidth += obj.children.length * 100
				columns.push(obj)
			}
		}
		this.setState({
			defauleTableWidth: tableWidth > 1740 ? '1740px' : tableWidth + 20
		})
		return columns
	}
	//改变会诊量统计查询表格表头
	checkTypeBack = (type, checkSearchTypeValue) => {
		let obj = {
			title: type === 0 ? "申请病例量" : type === 1 ? "会诊病例量" : "退回病例量",
			ellipsis: true,
			align: "center",
			children: [],
		}
		if (checkSearchTypeValue.includes(0)) {
			obj.children.push({
				title: "动态心电",
				dataIndex: type === 0 ? "HOLTER_APPLY" : type === 1 ? "HOLTER_Consulation_Sum" : "HOLTER_Exit_Sum",
				key: type === 0 ? "HOLTER_APPLY" : type === 1 ? "HOLTER_Consulation_Sum" : "HOLTER_Exit_Sum",
				align: "center",
				ellipsis: true,
				width: 100,
			})
		}
		if (checkSearchTypeValue.includes(1)) {
			obj.children.push({
				title: "动态血压",
				dataIndex: type === 0 ? "BP_APPLY" : type === 1 ? "BP_Consulation_Sum" : "BP_Exit_Sum",
				key: type === 0 ? "BP_APPLY" : type === 1 ? "BP_Consulation_Sum" : "BP_Exit_Sum",
				align: "center",
				ellipsis: true,
				width: 100,
			})
		}
		if (checkSearchTypeValue.includes(2)) {
			obj.children.push({
				title: "静息心电",
				dataIndex: type === 0 ? "ECG_APPLY" : type === 1 ? "ECG_Consulation_Sum" : "ECG_Exit_Sum",
				key: type === 0 ? "ECG_APPLY" : type === 1 ? "ECG_Consulation_Sum" : "ECG_Exit_Sum",
				align: "center",
				ellipsis: true,
				width: 100,
			})
		}
		if (checkSearchTypeValue.length > 0) {
			obj.children.push({
				title: "合计",
				dataIndex: type === 0 ? "APPLY_Total" : type === 1 ? "Consulation_Total" : "Exit_Total",
				key: type === 0 ? "APPLY_Total" : type === 1 ? "Consulation_Total" : "Exit_Total",
				align: "center",
				ellipsis: true,
				width: 100,
			})
		}
		return obj
	}
	//开单量统计=>机构名称变更事件
	handleBillHospitalValue = (code) => {
		this.setState({
			billHospitalCode: code,
			billDoctorValue: "",
			billDoctorList: [],
			billMonthDisabled: false,
		});
		this.initBillDoctorList(code);//获取开单量统计开单医生列表
	};
	//会诊量统计列表=>未选择会诊医院列表
	getConsultDataList = () => {
		let FIRST_GROUP_CODE = this.state.firstGroupValue ? this.state.firstGroupValue.toString() : ''//一级分组
		let SECOND_GROUP_CODE = this.state.secondGroupValue ? this.state.secondGroupValue.toString() : ''//二级分组
		if (FIRST_GROUP_CODE === '' && SECOND_GROUP_CODE !== '') {
			if (SECOND_GROUP_CODE.split(',').length > 1) {//如果不选一级分组只选二级分组，多选情况下需要取二级分组的名称
				let secondGroupArr = SECOND_GROUP_CODE.split(',')
				SECOND_GROUP_CODE = this.state.secondGroupList.filter(item => secondGroupArr.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => item.SECOND_GROUP_NAME).toString()
			} else {
				SECOND_GROUP_CODE = this.state.secondGroupList.find(item => item.SECOND_GROUP_CODE === SECOND_GROUP_CODE).SECOND_GROUP_NAME
			}
		}
		let { examSearchTypeValue, checkSearchTypeValue } = this.state
		let EXAM_CLASS = '', STATISTIC_TYPE = '';
		for (let i = 0; i < examSearchTypeValue.length; i++) {
			if (examSearchTypeValue[i] === 0) {
				STATISTIC_TYPE = STATISTIC_TYPE + 'APPLY,'
			}
			if (examSearchTypeValue[i] === 1) {
				STATISTIC_TYPE = STATISTIC_TYPE + 'Consulation,'
			}
			if (examSearchTypeValue[i] === 2) {
				STATISTIC_TYPE = STATISTIC_TYPE + 'Exit,'
			}
		}
		for (let i = 0; i < checkSearchTypeValue.length; i++) {
			if (checkSearchTypeValue[i] === 0) {
				EXAM_CLASS = EXAM_CLASS + 'HOLTER,'
			}
			if (checkSearchTypeValue[i] === 1) {
				EXAM_CLASS = EXAM_CLASS + 'BP,'
			}
			if (checkSearchTypeValue[i] === 2) {
				EXAM_CLASS = EXAM_CLASS + 'ECG,'
			}
		}
		let params = {
			HOSPITAL_CODE: this.state.consultHospitalValue,
			QUERY_BEG_YEAR: moment(this.state.startValue).format("YYYY"),
			FIRST_GROUP_CODE,//一级分组
			SECOND_GROUP_CODE,//二级分组
			IS_REGULATOR: this.state.isStystemOrSupervise ? this.state.userInfo.HOSPITAL_CODE : '',

			EXAM_CLASS: EXAM_CLASS.length > 0 ? EXAM_CLASS.slice(0, -1) : '',
			STATISTIC_TYPE: STATISTIC_TYPE.length > 0 ? STATISTIC_TYPE.slice(0, -1) : '',
		};
		if (this.state.consultationMonth) {
			params.QUERY_MONTH = this.state.consultationMonth;
		}
		let consultHospitalName = ''

		if (!this.state.isStystemOrSupervise) {
			consultHospitalName = this.state.userInfo.HOSPITAL_NAME
		} else {
			consultHospitalName = this.getConsultationName();
		}
		getConsultationTotal(params).then((res) => {
			if (res && res.Status === 1) {
				console.log(res.Result.list);
				this.setState({
					dataList: res.Result.list,
					consultHospitalName,
					selectStartValue: params.QUERY_BEG_YEAR,
					applyHospitalName: "",
					selectConsultationMonth: this.state.consultationMonth,
					isFixedHeJiHuiZhen: res.Result.list.length > 15 ? true : false,
					isLoadingData: false,
				});
			} else {
				this.setState({
					isLoadingData: false,
				})
				requestErrorLog('', '综合查询-统计报表-获取会诊量统计列表', 0, true)
			}
		});
	};
	//会诊量统计列表=>选择会诊医院列表
	getApplyHospitalConsultation = () => {
		let FIRST_GROUP_CODE = this.state.firstGroupValue ? this.state.firstGroupValue.toString() : ''//一级分组
		let SECOND_GROUP_CODE = this.state.secondGroupValue ? this.state.secondGroupValue.toString() : ''//二级分组
		if (FIRST_GROUP_CODE === '' && SECOND_GROUP_CODE !== '') {
			if (SECOND_GROUP_CODE.split(',').length > 1) {//如果不选一级分组只选二级分组，多选情况下需要取二级分组的名称
				let secondGroupArr = SECOND_GROUP_CODE.split(',')
				SECOND_GROUP_CODE = this.state.secondGroupList.filter(item => secondGroupArr.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => item.SECOND_GROUP_NAME).toString()
			} else {
				SECOND_GROUP_CODE = this.state.secondGroupList.find(item => item.SECOND_GROUP_CODE === SECOND_GROUP_CODE).SECOND_GROUP_NAME
			}
		}

		let { examSearchTypeValue, checkSearchTypeValue } = this.state
		let EXAM_CLASS = '', STATISTIC_TYPE = '';
		for (let i = 0; i < examSearchTypeValue.length; i++) {
			if (examSearchTypeValue[i] === 0) {
				STATISTIC_TYPE = STATISTIC_TYPE + 'APPLY,'
			}
			if (examSearchTypeValue[i] === 1) {
				STATISTIC_TYPE = STATISTIC_TYPE + 'Consulation,'
			}
			if (examSearchTypeValue[i] === 2) {
				STATISTIC_TYPE = STATISTIC_TYPE + 'Exit,'
			}
		}
		for (let i = 0; i < checkSearchTypeValue.length; i++) {
			if (checkSearchTypeValue[i] === 0) {
				EXAM_CLASS = EXAM_CLASS + 'HOLTER,'
			}
			if (checkSearchTypeValue[i] === 1) {
				EXAM_CLASS = EXAM_CLASS + 'BP,'
			}
			if (checkSearchTypeValue[i] === 2) {
				EXAM_CLASS = EXAM_CLASS + 'ECG,'
			}
		}
		let params = {
			HOSPITAL_CODE: this.state.consultHospitalValue,
			QUERY_YEAR: moment(this.state.startValue).format("YYYY"),
			APPLY_HOSPITAL_CODE: this.state.applyHospitalValue,
			IS_REGULATOR: this.state.isStystemOrSupervise ? this.state.userInfo.HOSPITAL_CODE : '',
			FIRST_GROUP_CODE,//一级分组
			SECOND_GROUP_CODE,//二级分组
			EXAM_CLASS: EXAM_CLASS.length > 0 ? EXAM_CLASS.slice(0, -1) : '',
			STATISTIC_TYPE: STATISTIC_TYPE.length > 0 ? STATISTIC_TYPE.slice(0, -1) : '',
		};
		let consultHospitalName = this.getConsultationName();
		let applyHospitalName = this.getApplyHospitalName();
		getApplyHospitalConsultation(params).then((res) => {
			if (res && res.Status === 1) {
				let list = res.Result.list;
				let total = res.Result.total || {};
				total.APPLY_HOSPITAL_NAME = "总计"
				let dataList = [];
				list.forEach((item) => {
					item.APPLY_HOSPITAL_NAME = item.MONTHDATE;
					dataList.push(item);
				});
				dataList.push(total);
				this.setState({
					applyHospitalName,
					selectStartValue: params.QUERY_YEAR,
					dataList,
					consultHospitalName,
					selectConsultationMonth: "",
					isLoadingData: false,
				});
			} else {
				this.setState({
					isLoadingData: false,
				})
				requestErrorLog('', '综合查询-统计报表-获取会诊量统计列表', 0, true)
			}
		});
	};
	//医生工作量统计=>弹出日历和关闭日历的回调
	handleEndOpenChange = (open) => {
		this.setState({ endOpen: open });
	};

	//医生工作量统计=>日历面板切换的回调
	handleEndPanelChange = (value) => {
		this.setState({
			endValue: value,
			endOpen: false,
		});
	};

	//获取会诊人
	initDoctorList = async (hospital_Code, FIRST_GROUP_CODE, SECOND_GROUP_CODE) => {
		FIRST_GROUP_CODE = FIRST_GROUP_CODE.toString()
		SECOND_GROUP_CODE = SECOND_GROUP_CODE.toString()
		let doctorParam = {
			Type: "GetDoctorList",
			hospital_Code,
			FIRST_GROUP_CODE,
			SECOND_GROUP_CODE,
		}
		let doctorListRes = await getSearchDoctorList(doctorParam);
		let doctorList = []
		if (doctorListRes && doctorListRes.Status === 1) {
			doctorList = doctorListRes.Result ? doctorListRes.Result : [];
		} else {
			requestErrorLog('', '综合查询-统计报表-获取会诊人列表', 0, true)
		}
		return doctorList
	};

	//会诊人改变
	doctorChange = (code) => {
		let doctorMonthDisabled = false;
		let { doctorMonth } = this.state;
		if (code !== "") {
			doctorMonthDisabled = true;
			doctorMonth = "";
		}
		this.setState({
			doctorValue: code,
			doctorMonthDisabled,
			doctorMonth,
		});
	};
	//开单量统计=>弹出日历和关闭日历的回调
	handleBillOpenChange = (open) => {
		this.setState({ billOpen: open });
	};
	//开单量统计=>弹出日历和关闭日历的回调
	handleBillPanelChange = (value) => {
		this.setState(
			{
				billValue: value,
				billOpen: false,
				billHospitalCode: "",
				billDoctorValue: "",
			},
			() => this.initBillHospitalList(this.state.firstGroupValue ? this.state.firstGroupValue : '', this.state.secondGroupValue ? this.state.secondGroupValue : ''),
			this.initBillDoctorList()
		);
	};

	//开单医生改变
	billDoctorChange = (name) => {
		let billMonthDisabled = false;
		let { billMonth } = this.state;
		if (name !== "") {
			billMonthDisabled = true;
			billMonth = "";
		}
		this.setState({
			billDoctorValue: name,
			billMonthDisabled,
			billMonth,
		});
	};

	//获取医生工作量数据
	getDoctorWorkload = () => {
		this.setState({
			isLoadingDoctor: true
		}, () => {
			let FIRST_GROUP_CODE = this.state.firstGroupValue ? this.state.firstGroupValue.toString() : ''//一级分组
			let SECOND_GROUP_CODE = this.state.secondGroupValue ? this.state.secondGroupValue.toString() : ''//二级分组
			if (FIRST_GROUP_CODE === '' && SECOND_GROUP_CODE !== '') {
				if (SECOND_GROUP_CODE.split(',').length > 1) {//如果不选一级分组只选二级分组，多选情况下需要取二级分组的名称
					let secondGroupArr = SECOND_GROUP_CODE.split(',')
					SECOND_GROUP_CODE = this.state.secondGroupList.filter(item => secondGroupArr.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => item.SECOND_GROUP_NAME).toString()
				} else {
					SECOND_GROUP_CODE = this.state.secondGroupList.find(item => item.SECOND_GROUP_CODE === SECOND_GROUP_CODE).SECOND_GROUP_NAME
				}
			}
			let params = {
				HOSPITAL_CODE: this.state.consultHospitalValue,
				QUERY_YEAR: moment(this.state.endValue).format("YYYY"),
				FIRST_GROUP_CODE,//一级分组
				SECOND_GROUP_CODE,//二级分组
				IS_REGULATOR: this.state.isStystemOrSupervise ? this.state.userInfo.HOSPITAL_CODE : '',
			};
			if (this.state.doctorValue) {
				params.CONSULTATION_DOCTOR_CODE = this.state.doctorValue?.split('&')[0];
			}
			if (this.state.doctorMonth) {
				params.QUERY_MONTH = this.state.doctorMonth;
			}
			let consultHospitalName = this.getConsultationName();
			getDoctorWorkload(params).then((res) => {
				if (res && res.Status === 1) {
					let list = res.Result.list;
					let total = res.Result.total;
					total.CONSULTATION_DOCTOR_NAME = "合计";
					if (list[0] && list[0].MONTHDATE) {
						list.forEach((item) => {
							item.CONSULTATION_DOCTOR_NAME = item.MONTHDATE;
						});
					}
					list.push(total);
					this.setState(
						{
							doctorWorkList: list,
							selectEndValue: params.QUERY_YEAR,
							consultHospitalName,
							isFixedHeJiYiSheng: list.length > 15 ? true : false,
							isLoadingDoctor: false,
						},
						() => {
							let selectdoctorName = "";
							let selectDoctorMonth = "";
							if (this.state.doctorValue) {
								selectdoctorName = this.state.doctorValue?.split('&')[1];
							}
							if (this.state.doctorMonth) {
								selectDoctorMonth = this.state.doctorMonth;
							}
							this.setState({
								selectdoctorName,
								selectDoctorMonth,
							});
						}
					);
				} else {
					this.setState({
						isLoadingDoctor: false,
					})
					requestErrorLog('', '综合查询-统计报表-获取医生工作量列表报错', 0, true)
				}
			});
		})

	};

	//获取医生开单量数据
	getBillDoctorWorkload = () => {
		this.setState({ isLoadingBill: true }, () => {
			let FIRST_GROUP_CODE = this.state.firstGroupValueBill ? this.state.firstGroupValueBill.toString() : ''//一级分组
			let SECOND_GROUP_CODE = this.state.secondGroupValueBill ? this.state.secondGroupValueBill.toString() : ''//二级分组
			if (FIRST_GROUP_CODE === '' && SECOND_GROUP_CODE !== '') {
				if (SECOND_GROUP_CODE.split(',').length > 1) {//如果不选一级分组只选二级分组，多选情况下需要取二级分组的名称
					let secondGroupArr = SECOND_GROUP_CODE.split(',')
					SECOND_GROUP_CODE = this.state.secondGroupListBill.filter(item => secondGroupArr.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => item.SECOND_GROUP_NAME).toString()
				} else {
					SECOND_GROUP_CODE = this.state.secondGroupListBill.find(item => item.SECOND_GROUP_CODE === SECOND_GROUP_CODE).SECOND_GROUP_NAME
				}
			}
			let params = {
				HOSPITAL_CODE: this.state.billHospitalCode,
				QUERY_YEAR: moment(this.state.billValue).format("YYYY"),
				FIRST_GROUP_CODE,//一级分组
				SECOND_GROUP_CODE,//二级分组
				IS_REGULATOR: this.state.isStystemOrSupervise ? this.state.userInfo.HOSPITAL_CODE : '',
			};
			if (this.state.billDoctorValue) {
				params.BILLING_DOCTOR = this.state.billDoctorValue?.split('&')[0];
			}
			if (this.state.billMonth) {
				params.QUERY_MONTH = this.state.billMonth;
			}
			let billHospitalName = this.getBillHospitalName();
			getBillDoctorWorkload(params).then((res) => {
				if (res && res.Status === 1) {
					let list = res.Result.list;
					let total = res.Result.total;
					total.BILLING_DOCTOR = "合计";
					if (list[0] && list[0].MONTHDATE) {
						list.forEach((item) => {
							item.BILLING_DOCTOR = item.MONTHDATE;
						});
					}
					list.push(total);
					this.setState(
						{
							billDoctorWorkList: list,
							selectEndValue: params.QUERY_YEAR,
							billHospitalName,
							billHospitalCodeName: this.state.billHospitalCode,
							isFixedHeJiKaiDan: list.length > 15 ? true : false,
							isLoadingBill: false,
						},
						() => {
							let selectBillDoctorName = "";
							let selectBillMonth = "";
							if (this.state.billDoctorValue) {
								selectBillDoctorName = this.state.billDoctorValue?.split('&')[0];
							}
							if (this.state.billMonth) {
								selectBillMonth = this.state.billMonth;
							}
							this.setState({
								selectBillDoctorName,
								selectBillMonth,
							});
						}
					);
				} else {
					requestErrorLog('', '综合查询-统计报表-获取医生开单量数据', 0, true)
					this.setState({
						isLoadingBill: false,
					})
				}
			});
		})


	};

	//会诊量统计导出
	exportConsultationVolume = () => {
		this.setState({
			isLoadingExportData: true
		}, () => {
			let HOSPITAL_NAME = this.getConsultationName();
			let FIRST_GROUP_CODE = this.state.firstGroupValue ? this.state.firstGroupValue.toString() : ''//一级分组
			let SECOND_GROUP_CODE = this.state.secondGroupValue ? this.state.secondGroupValue.toString() : ''//二级分组
			if (FIRST_GROUP_CODE === '' && SECOND_GROUP_CODE !== '') {
				if (SECOND_GROUP_CODE.split(',').length > 1) {//如果不选一级分组只选二级分组，多选情况下需要取二级分组的名称
					let secondGroupArr = SECOND_GROUP_CODE.split(',')
					SECOND_GROUP_CODE = this.state.secondGroupList.filter(item => secondGroupArr.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => item.SECOND_GROUP_NAME).toString()
				} else {
					SECOND_GROUP_CODE = this.state.secondGroupList.find(item => item.SECOND_GROUP_CODE === SECOND_GROUP_CODE).SECOND_GROUP_NAME
				}
			}
			let params = {
				HOSPITAL_CODE: this.state.consultHospitalValue,
				HOSPITAL_NAME,
				QUERY_YEAR: moment(this.state.startValue).format("YYYY"),
				FIRST_GROUP_CODE,//一级分组
				SECOND_GROUP_CODE,//二级分组
				IS_REGULATOR: this.state.isStystemOrSupervise ? this.state.userInfo.HOSPITAL_CODE : '',
				IS_ADDITIONAL_INFO: 0,
			};
			if (this.state.applyHospitalValue) {
				let APPLY_HOSPITAL_NAME = this.getApplyHospitalName();
				params.APPLY_HOSPITAL_CODE = this.state.applyHospitalValue;
				params.APPLY_HOSPITAL_NAME = APPLY_HOSPITAL_NAME;
			}
			if (this.state.consultationMonth) {
				params.QUERY_MONTH = this.state.consultationMonth;
			}
			getExportConsultationVolume(params).then((res) => {
				if (res && res.Status === 1) {
					window.location.href = window.g.baseURL + "\\" + res.Result;
					this.setState({
						isLoadingExportData: false
					})
				} else {
					this.setState({
						isLoadingExportData: false
					})
					requestErrorLog('', '综合查询-统计报表-导出会诊量统计报错', 0, true)
				}
			});
		})

	};

	//医生工作量导出
	exportDoctorWorkload = () => {
		this.setState({
			isLoadingExportDoctor: true
		}, () => {
			let HOSPITAL_NAME = this.getConsultationName();
			let FIRST_GROUP_CODE = this.state.firstGroupValue ? this.state.firstGroupValue.toString() : ''//一级分组
			let SECOND_GROUP_CODE = this.state.secondGroupValue ? this.state.secondGroupValue.toString() : ''//二级分组
			if (FIRST_GROUP_CODE === '' && SECOND_GROUP_CODE !== '') {
				if (SECOND_GROUP_CODE.split(',').length > 1) {//如果不选一级分组只选二级分组，多选情况下需要取二级分组的名称
					let secondGroupArr = SECOND_GROUP_CODE.split(',')
					SECOND_GROUP_CODE = this.state.secondGroupList.filter(item => secondGroupArr.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => item.SECOND_GROUP_NAME).toString()
				} else {
					SECOND_GROUP_CODE = this.state.secondGroupList.find(item => item.SECOND_GROUP_CODE === SECOND_GROUP_CODE).SECOND_GROUP_NAME
				}
			}
			let params = {
				HOSPITAL_CODE: this.state.consultHospitalValue,
				HOSPITAL_NAME,
				QUERY_YEAR: moment(this.state.endValue).format("YYYY"),
				FIRST_GROUP_CODE,//一级分组
				SECOND_GROUP_CODE,//二级分组
				IS_REGULATOR: this.state.isStystemOrSupervise ? this.state.userInfo.HOSPITAL_CODE : '',
			};
			if (this.state.doctorValue) {
				params.CONSULTATION_DOCTOR_CODE = this.state.doctorValue?.split('&')[0];
				params.CONSULTATION_DOCTOR_NAME = this.state.doctorValue?.split('&')[1];

			}
			if (this.state.doctorMonth) {
				params.QUERY_MONTH = this.state.doctorMonth;
			}
			getExportDoctorWorkload(params).then((res) => {
				if (res && res.Status === 1) {
					window.location.href = window.g.baseURL + "\\" + res.Result;
					this.setState({
						isLoadingExportDoctor: false
					})
				} else {
					this.setState({
						isLoadingExportDoctor: false
					})
					requestErrorLog('', '综合查询-统计报表-导出医生工作量报错', 0, true)
				}
			});
		})
	};

	//医生开单量导出
	exportBillDoctorWorkload = () => {
		this.setState({
			isLoadingExportBill: true
		}, () => {
			let FIRST_GROUP_CODE = this.state.firstGroupValueBill ? this.state.firstGroupValueBill.toString() : ''//一级分组
			let SECOND_GROUP_CODE = this.state.secondGroupValueBill ? this.state.secondGroupValueBill.toString() : ''//二级分组
			if (FIRST_GROUP_CODE === '' && SECOND_GROUP_CODE !== '') {
				if (SECOND_GROUP_CODE.split(',').length > 1) {//如果不选一级分组只选二级分组，多选情况下需要取二级分组的名称
					let secondGroupArr = SECOND_GROUP_CODE.split(',')
					SECOND_GROUP_CODE = this.state.secondGroupListBill.filter(item => secondGroupArr.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => item.SECOND_GROUP_NAME).toString()
				} else {
					SECOND_GROUP_CODE = this.state.secondGroupListBill.find(item => item.SECOND_GROUP_CODE === SECOND_GROUP_CODE).SECOND_GROUP_NAME
				}
			}
			let params = {
				QUERY_YEAR: moment(this.state.billValue).format("YYYY"),
				HOSPITAL_CODE: this.state.billHospitalCode,
				HOSPITAL_NAME: this.state.billHospitalName,
				FIRST_GROUP_CODE,//一级分组
				SECOND_GROUP_CODE,//二级分组
				IS_REGULATOR: this.state.isStystemOrSupervise ? this.state.userInfo.HOSPITAL_CODE : '',
			};
			if (this.state.billDoctorValue) {
				params.BILLING_DOCTOR = this.state.billDoctorValue?.split('&')[0];
			}
			if (this.state.billMonth) {
				params.QUERY_MONTH = this.state.billMonth;
			}
			getExportBillDoctorWorkload(params).then((res) => {
				if (res && res.Status === 1) {
					window.location.href = window.g.baseURL + "\\" + res.Result;
					this.setState({
						isLoadingExportBill: false
					})
				} else {
					this.setState({
						isLoadingExportBill: false
					})
					requestErrorLog('', '综合查询-统计报表-导出医生开单量报错', 0, true)
				}
			});
		})
	};
	//一级组别变化
	firstGroupChange = async (firstGroupCode) => {
		let firstGroupName = firstGroupCode.length > 0 ? this.state.firstGroupList.filter(item => firstGroupCode.indexOf(item.FIRST_GROUP_CODE) > -1).map((item) => { return item.FIRST_GROUP_NAME }) : ''
		//非平台管理和监管机构账号，会诊机构和开单量统计机构下拉框disable，不允许清空,列表数据也对应重新获取或者清空
		const { isStystemOrSupervise } = this.state
		//二次需求：一级分组为空也请求二级分组列表
		let firstArr = this.state.firstGroupList.map(obj => obj.FIRST_GROUP_CODE)
		let secondGroupList = firstGroupCode.length > 0 ? await this.getSearchPartSecondData(firstGroupCode) : await this.getSearchPartSecondData(firstArr)
		if (!firstGroupCode.length > 0) {
			secondGroupList = uniqueJsonArrByField(secondGroupList, 'SECOND_GROUP_NAME')
		}

		//分组1勾选时，给分组二的全选框赋空
		let indeterminateSecond = false;
		let selectSecondAllState = false;
		let indeterminateFirst = false;
		let selectFirstAllState = false;
		//选中的数据不等于全选的数据长度，全选框为半选状态
		if (firstGroupCode.length > 0 && firstGroupCode.length < this.state.firstGroupList.length) {
			indeterminateFirst = true
		} else {
			if (firstGroupCode.length === this.state.firstGroupList.length) {
				selectFirstAllState = true
			}
		}
		this.setState({
			firstGroupValue: firstGroupCode,
			firstGroupName,
			secondGroupName: '',
			secondGroupValue: undefined,//分组二下拉框清空
			consultHospitalValue: isStystemOrSupervise ? '' : this.state.consultHospitalValue,//会诊机构下拉框清空
			applyHospitalValue: '',//申请机构下拉框清空
			doctorValue: '',//会真人下拉框清空

			secondGroupList,//二级分组列表数据
			consultHospitalList: isStystemOrSupervise ? [] : this.state.consultHospitalList,//会诊医院列表清空
			applyHospitalList: [],//申请医院列表清空
			doctorList: [],//会诊人列表情空
			consultationMonthDisabled: false,
			doctorMonthDisabled: false,
			isChangeconsultHospitalNameOrList: true,//切换到标签四是否要刷新列表请求后端

			indeterminateSecond,
			selectSecondAllState,
			indeterminateFirst,
			selectFirstAllState,
		})

	}

	//请求二级分组列表
	async getSearchPartSecondData(firstGroupData) {
		let res = await getSearchPartSecondData("E00117", this.state.userInfo.HOSPITAL_CODE, firstGroupData.toString())
		if (res && res.Status === 1) {
			return res.Result ? res.Result : []
		} else {
			requestErrorLog('', '综合查询-统计报表-获取二级分组列表报错', 0, true)
			return []
		}
	}
	//二级组别变化
	secondGroupChange = async (secondGroupData) => {
		if (this.state.firstGroupValue.length > 0) {//二次需求：一级分组为空也请求二级分组列表；单纯二级分组发生变化，不处理原来搜索框联动逻辑
			//非平台管理和监管机构账号，会诊机构和开单量统计机构下拉框disable，不允许清空,列表数据也对应重新获取或者清空
			let secondGroupName = secondGroupData.length > 0 ? this.state.secondGroupList.filter(item => secondGroupData.indexOf(item.SECOND_GROUP_CODE) > -1).map((item) => { return item.SECOND_GROUP_NAME }) : ''
			const { isStystemOrSupervise } = this.state
			let consultHospitalList = [], applyHospitalList = []
			this.setState({
				secondGroupName: secondGroupData.length > 0 ? secondGroupName : '',
				secondGroupValue: secondGroupData,//分组二下拉框清空
			})
			let stateObject = {
				consultHospitalValue: isStystemOrSupervise ? '' : this.state.consultHospitalValue,//会诊机构下拉框清空
				applyHospitalValue: '',//申请机构下拉框清空
				doctorValue: '',//会真人下拉框清空
				consultHospitalList,//会诊医院列表赋值
				applyHospitalList,//申请医院列表清空
				doctorList: [],//会诊人列表情空
				consultationMonthDisabled: false,
				doctorMonthDisabled: false,
				isChangeconsultHospitalNameOrList: true,//切换到标签四是否要刷新列表请求后端
			}
			if (secondGroupData.length > 0) {
				if (isStystemOrSupervise) {
					stateObject.consultHospitalList = await this.initConsultHospitalList(this.state.firstGroupValue, secondGroupData)
				} else {
					stateObject.consultHospitalList = this.state.consultHospitalList
					//会诊医院账号登陆，二级组别选完后，需要带出对应的申请机构、会诊人
					stateObject.applyHospitalList = await this.initApplyHostpitalList(this.state.consultHospitalValue, this.state.firstGroupValue, secondGroupData)//申请机构列表
					stateObject.doctorList = await this.initDoctorList(this.state.consultHospitalValue, this.state.firstGroupValue, secondGroupData)//会诊人列表
				}
			} else {
				stateObject.consultHospitalList = isStystemOrSupervise ? [] : this.state.consultHospitalList
			}
			this.setState(stateObject)
		} else {
			let secondGroupName = secondGroupData.length > 0 ? this.state.secondGroupList.filter(item => secondGroupData.indexOf(item.SECOND_GROUP_CODE) > -1).map((item) => { return item.SECOND_GROUP_NAME }) : ''
			this.setState({
				secondGroupValue: secondGroupData,
				secondGroupName: secondGroupData.length > 0 ? secondGroupName : '',
			})
		}
		//分组1勾选时，给分组二的全选框赋空
		let indeterminateSecond = false;
		let selectSecondAllState = false;
		//选中的数据不等于全选的数据长度，全选框为半选状态
		if (secondGroupData.length > 0 && secondGroupData.length < this.state.secondGroupList.length) {
			indeterminateSecond = true
		} else {
			if (secondGroupData.length === this.state.secondGroupList.length) {
				selectSecondAllState = true
			}
		}
		this.setState({
			indeterminateSecond,
			selectSecondAllState
		})
	}
	//获取选择开单医院的名字
	getBillHospitalName = () => {
		let BILL_HOSPITAL_NAME = "";
		this.state.billApplyHospitalList.forEach((item) => {
			if (item.APPLY_HOSPITAL_CODE === this.state.billHospitalCode) {
				BILL_HOSPITAL_NAME = item.APPLY_HOSPITAL_NAME;
			}
		});
		return BILL_HOSPITAL_NAME;
	};

	//获取选择的会诊医院名字
	getConsultationName = () => {
		let HOSPITAL_NAME = "";
		if (this.state.consultHospitalList) {
			this.state.consultHospitalList.forEach((item) => {
				if (item.HOSPITAL_CODE === this.state.consultHospitalValue) {
					HOSPITAL_NAME = item.HOSPITAL_NAME;
				}
			});
		}
		return HOSPITAL_NAME;
	};
	//获取选择的申请医院的名字
	getApplyHospitalName = () => {
		let HOSPITAL_NAME = "";
		this.state.applyHospitalList.forEach((item) => {
			if (item.APPLY_HOSPITAL_CODE === this.state.applyHospitalValue) {
				HOSPITAL_NAME = item.APPLY_HOSPITAL_NAME;
			}
		});
		return HOSPITAL_NAME;
	};
	//会诊量统计选择的月份
	changeConsultationMonth = (e) => {
		this.setState({
			consultationMonth: e,
		});
	};
	//医生工作量统计选择的月份
	changeDoctorMonth = (e) => {
		this.setState({
			doctorMonth: e,
		});
	};
	//医生工作量统计选择的月份
	changeBillMonth = (e) => {
		console.log(e, "billMonth");
		this.setState({
			billMonth: e,
		});
	};
	//增加套餐检查量统计模块

	//获取套餐检查量表头和数据type：区别表头和表数据；consultHospitalList：接口必须传医院code，如果没选，传第一项；
	getPackageTableData = async (type) => {
		//获取检查项目套餐表头
		let packageColumns = [
		]
		const { applyHospitalList, checkTypeID, checkSubclassID, checkProjectID, applyHospitalValue, CONSULTATION_STATUS, EXAM_STATUS, startDate, endDate, consultHospitalValue, } = this.state
		let hospitalCode = consultHospitalValue !== '' ? consultHospitalValue : ''
		let consultHospitalName = this.getConsultationName();
		//更新查询内容，能查到会诊医院名称显示会诊医院名称，查不到显示code
		let hospitaApplylName = applyHospitalList.find((item) => item.APPLY_HOSPITAL_CODE === applyHospitalValue) ? applyHospitalList.find((item) => item.APPLY_HOSPITAL_CODE === applyHospitalValue).APPLY_HOSPITAL_NAME : applyHospitalValue
		let searchTime = ''
		searchTime = moment(startDate).format('YYYY-MM-DD') + ' - ' + moment(endDate).format('YYYY-MM-DD')
		this.setState({
			applyHospitalName: hospitaApplylName,
			consultHospitalName: consultHospitalName,
			searchTime,
		})

		let FIRST_GROUP_CODE = this.state.firstGroupValue ? this.state.firstGroupValue.toString() : ''//一级分组
		let SECOND_GROUP_CODE = this.state.secondGroupValue ? this.state.secondGroupValue.toString() : ''//二级分组
		if (FIRST_GROUP_CODE === '' && SECOND_GROUP_CODE !== '') {
			if (SECOND_GROUP_CODE.split(',').length > 1) {//如果不选一级分组只选二级分组，多选情况下需要取二级分组的名称
				let secondGroupArr = SECOND_GROUP_CODE.split(',')
				SECOND_GROUP_CODE = this.state.secondGroupList.filter(item => secondGroupArr.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => item.SECOND_GROUP_NAME).toString()
			} else {
				SECOND_GROUP_CODE = this.state.secondGroupList.find(item => item.SECOND_GROUP_CODE === SECOND_GROUP_CODE).SECOND_GROUP_NAME
			}
		}
		let packageParam = {
			Type: type === "header" ? "GetTableData" : this.state.institutionOrPerson === 0 ? "GetPackageData" : 'GetDoctorPackageData',
			EXAM_CLASS: checkTypeID ? checkTypeID : '',//检查类型
			EXAM_SUB_CLASS: checkSubclassID?.split('&')[0] || '',//检查子类
			EXAM_ITEM: checkProjectID?.split('&')[0] || '',//检查项目
			HOSPITAL_CODE: hospitalCode,//所属医院
			APPLY_HOSPITAL_CODE: applyHospitalValue ? applyHospitalValue : '',//申请机构
			CONSULTATION_STATUS: CONSULTATION_STATUS ? CONSULTATION_STATUS : '',//会诊状态
			EXAM_STATUS: EXAM_STATUS ? EXAM_STATUS : '',//报告状态
			EXAM_DATETIME: [moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')],//检查时间

			FIRST_GROUP_CODE,//一级分组
			SECOND_GROUP_CODE,//二级分组
			IS_REGULATOR: this.state.isStystemOrSupervise ? this.state.userInfo.HOSPITAL_CODE : '',
		}
		let packageRes = await GetTableHeaderData("E00117", packageParam);

		let divWidth = document.getElementById('packageStatisticsTableBox')?.offsetWidth;
		if (!divWidth) {//套餐量统计为渲染时
			divWidth = document.getElementById('replacePackageStatisticsTableBox')?.offsetWidth;
		}
		let tableWidth = this.state.institutionOrPerson === 0 ? 680 : 120;//表格宽度如果占不满父级div ，宽度无效会被百分比撑开，固定列和table第一列宽度不一样，样式错乱
		if (type === 'header') {
			if (packageRes && packageRes.Status === 1) {
				let result = packageRes.Result;
				let typeChildren = [];
				let backgroundColorClass = ''
				for (let i = 0; i < result.length; i++) {
					if (result[i].EXAM_CLASS_CODE === 'ECG' || result[i].EXAM_CLASS_CODE === 'Holter' || result[i].EXAM_CLASS_CODE === 'BloodPressure') {
						let subArr = result[i].SUB_DATA
						let subChildren = []
						if (result[i].EXAM_CLASS_CODE === 'Holter') {
							backgroundColorClass = 'tableHeaderClass1'
						} else if (result[i].EXAM_CLASS_CODE === 'BloodPressure') {
							backgroundColorClass = 'tableHeaderClass2'
						}
						for (let j = 0; j < subArr.length; j++) {
							let projectArr = subArr[j].ITEM_DATA
							let projectChildren = []
							for (let k = 0; k < projectArr.length; k++) {
								let singleProject = {}
								singleProject = {
									dataIndex: projectArr[k].ITEM_CODE,
									key: projectArr[k].ITEM_CODE,
									title: () => (
										<span>
											<Tooltip
												title={projectArr[k].ITEM_NAME}
											>
												{projectArr[k].ITEM_NAME}
											</Tooltip>
										</span>
									),
									titleSpare: projectArr[k].ITEM_NAME,
									width: '100px',
									ellipsis: true,
									align: 'center',
									className: backgroundColorClass,
									render: (text) => {
										if (text) {
											return text.toString()
										}
										else {
											return 0
										}
									},
								}
								tableWidth += 100
								projectChildren.push(singleProject)
								//每个分类最后一行是横向合计
								if (j === subArr.length - 1 && k === projectArr.length - 1) {
									let totalType = ''
									if (projectArr[k].ITEM_CODE.indexOf('BloodPressure') > -1) {
										totalType = 'BloodPressureTOTAL'
									} else if (projectArr[k].ITEM_CODE.indexOf('ECG') > -1) {
										totalType = 'ECGTOTAL'
									} else if (projectArr[k].ITEM_CODE.indexOf('Holter') > -1) {
										totalType = 'HolterTOTAL'
									}
									projectChildren.push({
										dataIndex: totalType,
										title: '合计',
										width: '100px',
										ellipsis: true,
										align: 'center',
										className: backgroundColorClass,
										render: (text) => {
											if (text) {
												return text
											}
											else {
												return 0
											}
										},
									})
									//计算每个分类加上合计列总长度
									tableWidth += 100
								}

							}
							let singleArr = {
								title: () => (
									<span>
										<Tooltip
											title={subArr[j].EXAM_SUB_CLASS}
										>
											{subArr[j].EXAM_SUB_CLASS}
										</Tooltip>
									</span>
								),
								titleSpare: subArr[j].EXAM_SUB_CLASS,
								children: projectChildren,
								className: backgroundColorClass,
								width: '100px',
								align: 'center',
								ellipsis: true,
							}
							subChildren.push(singleArr)
						}
						let singleType = {
							title: result[i].EXAM_CLASS,
							children: subChildren,
							className: backgroundColorClass
						}
						typeChildren.push(singleType)
					} else {
						continue;
					}
				}
				this.setState({
					tableWidth,
				})
				//计算如果表格长度超过展示长度，固定第一列，否则不需要
				if (tableWidth > divWidth) {
					if (this.state.institutionOrPerson === 0) {
						packageColumns[0] = {
							title: "",
							fixed: 'left',
							className: checkTypeID ? backgroundColorClass : '',
							children: [
								{
									title: "",
									fixed: 'left',
									className: checkTypeID ? backgroundColorClass : '',
									children: [
										{
											title: "一级分组",
											// ellipsis: true,
											dataIndex: 'FIRST_GROUP_NAME',
											width: '120px',
											align: "left",
											fixed: 'left',
											className: checkTypeID ? backgroundColorClass : '',
											onCell: () => {
												return {
													style: {
														maxWidth: '100px',
														overflow: 'hidden',
														whiteSpace: 'nowrap',
														textOverflow: 'ellipsis',
														cursor: 'pointer'
													}
												}
											},
											render: (text) => {
												//生成序号
												return <span title={text}>
														{text}
												</span>;
											},

										},
									]
								},
							],
						}
						packageColumns[1] = {
							title: "",
							fixed: 'left',
							className: checkTypeID ? backgroundColorClass : '',
							children: [
								{
									title: "",
									fixed: 'left',
									className: checkTypeID ? backgroundColorClass : '',
									children: [
										{
											title: "二级分组",
											// ellipsis: true,
											dataIndex: 'SECOND_GROUP_NAME',
											width: '240px',
											align: "left",
											fixed: 'left',
											className: checkTypeID ? backgroundColorClass : '',
											onCell: () => {
												return {
													style: {
														maxWidth: '100px',
														overflow: 'hidden',
														whiteSpace: 'nowrap',
														textOverflow: 'ellipsis',
														cursor: 'pointer'
													}
												}
											},
											render: (text) => {
												//生成序号
												return <span title={text}>
														{text}
													{/* <Tooltip title={text}>
													</Tooltip> */}
												</span>;
											},
										},
									]
								},
							],
						}
						packageColumns[2] = {
							title: "",
							fixed: 'left',
							className: checkTypeID ? backgroundColorClass : '',
							children: [
								{
									title: "",
									fixed: 'left',
									className: checkTypeID ? backgroundColorClass : '',
									children: [
										{
											// ellipsis: true,
											title: "申请机构名称",
											dataIndex: "HOSPITAL_NAME",
											width: '320px',
											align: "left",
											fixed: 'left',
											className: checkTypeID ? backgroundColorClass : '',
											onCell: () => {
												return {
													style: {
														maxWidth: '300px',
														overflow: 'hidden',
														whiteSpace: 'nowrap',
														textOverflow: 'ellipsis',
														cursor: 'pointer'
													}
												}
											},
											render: (text) => {
												//生成序号
												return <span>
													<Tooltip title={text}>
														{text}
													</Tooltip>
												</span>;
											},
										},
									]
								},
							],
						}
					} else {
						packageColumns[0] = {
							title: "",
							fixed: 'left',
							className: checkTypeID ? backgroundColorClass : '',
							children: [
								{
									title: "",
									fixed: 'left',
									className: checkTypeID ? backgroundColorClass : '',
									children: [
										{
											// ellipsis: true,
											title: "报告医生",
											dataIndex: 'REAL_NAME',
											width: '120px',
											align: "center",
											fixed: 'left',
											className: checkTypeID ? backgroundColorClass : '',
											onCell: () => {
												return {
													style: {
														maxWidth: '100px',
														overflow: 'hidden',
														whiteSpace: 'nowrap',
														textOverflow: 'ellipsis',
														cursor: 'pointer'
													}
												}
											},
											render: (text) => {
												return <span>
													<Tooltip title={text}>
														{text}
													</Tooltip>
												</span>;
											},
										},
									]
								},
							],
						}
					}
				} else {
					if (this.state.institutionOrPerson === 0) {

						packageColumns[0] = {
							title: "",
							className: checkTypeID ? backgroundColorClass : '',
							children: [
								{
									title: "",
									className: checkTypeID ? backgroundColorClass : '',
									children: [
										{
											title: "一级分组",
											dataIndex: 'FIRST_GROUP_NAME',
											ellipsis: true,
											width: '120px',
											align: "left",
											className: checkTypeID ? backgroundColorClass : '',
											render: (text) => {
												//生成序号
												return <span title={text}>
														{text}
												</span>;
											},
										},
									]
								},
							],
						}
						packageColumns[1] = {
							title: "",
							className: checkTypeID ? backgroundColorClass : '',
							children: [
								{
									title: "",
									className: checkTypeID ? backgroundColorClass : '',
									children: [
										{
											title: "二级分组",
											dataIndex: 'SECOND_GROUP_NAME',
											ellipsis: true,
											width: '240px',
											align: "left",
											className: checkTypeID ? backgroundColorClass : '',
											render: (text) => {
												//生成序号
												return <span title={text}>
														{text}
													{/* <Tooltip title={text}>
													</Tooltip> */}
												</span>;
											},
										},
									]
								},
							],
						}
						packageColumns[2] = {
							title: "",
							className: checkTypeID ? backgroundColorClass : '',
							children: [
								{
									title: "",
									className: checkTypeID ? backgroundColorClass : '',
									children: [
										{
											title: "申请机构名称",
											ellipsis: true,
											dataIndex: "HOSPITAL_NAME",
											width: '320px',
											align: "left",
											className: checkTypeID ? backgroundColorClass : '',
											render: (text) => {
												//生成序号
												return <span>
													<Tooltip title={text}>
														{text}
													</Tooltip>
												</span>;
											},
										},
									]
								},
							],
						}
					} else {
						packageColumns[0] = {
							title: "",
							className: checkTypeID ? backgroundColorClass : '',
							children: [
								{
									title: "",
									className: checkTypeID ? backgroundColorClass : '',
									children: [
										{
											title: "报告医生",
											ellipsis: true,
											dataIndex: 'REAL_NAME',
											width: '120',
											align: "center",
											className: checkTypeID ? backgroundColorClass : '',
										},
									]
								},
							],
						}
					}
				}
				packageColumns = packageColumns.concat(typeChildren);
				return packageColumns
			} else {
				requestErrorLog('', '综合查询-统计报表-套餐检查量获取检查项目报错', 0, true)
				message.warn('获取检查项目失败')
				this.setState({
					isLoading: false
				})
				return []
			}
		} else if (type === 'data') {
			if (packageRes && packageRes.Status === 1) {
				//处理数据，做一个竖向的合计
				let data = packageRes.Result;
				let sumData = JSON.parse(JSON.stringify(data));
				let objSUM = {
				};
				// let sum = values.reduce((prev, cur, index, array) => prev + cur);
				if (sumData.length > 0) {
					objSUM = sumData.reduce((preRes, next,) => {
						if (!preRes) preRes = {}
						Object.keys(next).forEach((key) => {
							if (key !== 'HOSPITAL_CODE' && key !== 'HOSPITAL_NAME' && key !== 'REAL_NAME' && key !== 'USER_UID') {
								//返回的数据中有num和字符串，需转换
								if (next[key]) {
									let nextKey = parseInt(next[key]);
									preRes[key] = (preRes[key] ? parseInt(preRes[key]) : 0) + nextKey
								}
							}
							if (key === 'HOSPITAL_NAME' || key === 'REAL_NAME') {
								preRes[key] = preRes[key].length > next[key].length ? preRes[key] : next[key]
							}
						})
						return preRes
					})
				}
				if (this.state.institutionOrPerson === 0) {
					objSUM.HOSPITAL_CODE = 'heji'
					objSUM.HOSPITAL_NAME = '合计'
					objSUM.FIRST_GROUP_NAME = ''
					objSUM.SECOND_GROUP_NAME = ''
				} else {
					objSUM.USER_UID = 'heji'
					objSUM.REAL_NAME = '合计'
				}
				data.push(objSUM);

				let backgroundColorClass = ''
				if (checkTypeID === 'Holter') {
					backgroundColorClass = 'tableHeaderClass1'
				} else if (checkTypeID === 'BloodPressure') {
					backgroundColorClass = 'tableHeaderClass2'
				}
				let packageColumns = this.state.packageColumns;
				let tableWidth = this.state.tableWidth;
				if (tableWidth > divWidth) {
					if (this.state.institutionOrPerson === 0) {

						packageColumns[0] = {
							title: "",
							fixed: 'left',
							className: backgroundColorClass,
							children: [
								{
									title: "",
									fixed: 'left',
									className: backgroundColorClass,
									children: [
										{
											title: "一级分组",
											// ellipsis: true,
											dataIndex: 'FIRST_GROUP_NAME',
											width: '120px',
											align: "left",
											fixed: 'left',
											className: backgroundColorClass,
											onCell: () => {
												return {
													style: {
														maxWidth: '100px',
														overflow: 'hidden',
														whiteSpace: 'nowrap',
														textOverflow: 'ellipsis',
														cursor: 'pointer'
													}
												}
											},
											render: (text) => {
												//生成序号
												return <span title={text}>
														{text}
												</span>;
											},
										},
									]
								},
							],
						}
						packageColumns[1] = {
							title: "",
							fixed: 'left',
							className: backgroundColorClass,
							children: [
								{
									title: "",
									fixed: 'left',
									className: backgroundColorClass,
									children: [
										{
											title: "二级分组",
											// ellipsis: true,
											dataIndex: 'SECOND_GROUP_NAME',
											width: '240px',
											align: "left",
											fixed: 'left',
											className: backgroundColorClass,
											onCell: () => {
												return {
													style: {
														maxWidth: '100px',
														overflow: 'hidden',
														whiteSpace: 'nowrap',
														textOverflow: 'ellipsis',
														cursor: 'pointer'
													}
												}
											},
											render: (text) => {
												//生成序号
												return <span title={text}>
														{text}
													{/* <Tooltip title={text}>
													</Tooltip> */}
												</span>;
											},
										},
									]
								},
							],
						}
						packageColumns[2] = {
							title: "",
							fixed: 'left',
							className: backgroundColorClass,
							children: [
								{
									title: "",
									fixed: 'left',
									className: backgroundColorClass,
									children: [
										{
											title: "申请机构名称",
											// ellipsis: true,
											dataIndex: "HOSPITAL_NAME",
											width: '320px',
											align: "left",
											fixed: 'left',
											className: backgroundColorClass,
											onCell: () => {
												return {
													style: {
														maxWidth: '300px',
														overflow: 'hidden',
														whiteSpace: 'nowrap',
														textOverflow: 'ellipsis',
														cursor: 'pointer'
													}
												}
											},
											render: (text) => {
												//生成序号
												return <span>
													<Tooltip title={text}>
														{text}
													</Tooltip>
												</span>;
											},
										},
									]
								},
							],
						}
					}
					else {
						packageColumns[0] = {
							title: "",
							fixed: 'left',
							className: backgroundColorClass,
							children: [
								{
									title: "",
									fixed: 'left',
									className: backgroundColorClass,
									children: [
										{
											title: "报告医生",
											// ellipsis: true,
											dataIndex: 'REAL_NAME',
											width: '120px',
											align: "center",
											fixed: 'left',
											className: backgroundColorClass,
											onCell: () => {
												return {
													style: {
														maxWidth: '100px',
														overflow: 'hidden',
														whiteSpace: 'nowrap',
														textOverflow: 'ellipsis',
														cursor: 'pointer'
													}
												}
											},
											render: (text) => {
												return <span>
													<Tooltip title={text}>
														{text}
													</Tooltip>
												</span>;
											},
										},
									]
								},
							],
						}
					}
					this.setState({
						packageColumns
					})
				} else {
					if (this.state.institutionOrPerson === 0) {

						packageColumns[0] = {
							title: "",
							className: backgroundColorClass,
							children: [
								{
									title: "",
									className: backgroundColorClass,
									children: [
										{
											title: "一级分组",
											ellipsis: true,
											dataIndex: 'FIRST_GROUP_NAME',
											width: '120px',
											align: "left",
											className: backgroundColorClass,
											render: (text) => {
												//生成序号
												return <span title={text}>
														{text}
					
												</span>;
											},
										},
									]
								},
							],
						}
						packageColumns[1] = {
							title: "",
							className: backgroundColorClass,
							children: [
								{
									title: "",
									className: backgroundColorClass,
									children: [
										{
											title: "二级分组",
											ellipsis: true,
											dataIndex: 'SECOND_GROUP_NAME',
											width: '240px',
											align: "left",
											className: backgroundColorClass,
											render: (text) => {
												//生成序号
												return <span title={text}>
														{text}
													{/* <span title={text}>
													</span> */}
												</span>;
											},
										},
									]
								},
							],
						}
						packageColumns[2] = {
							title: "",
							className: backgroundColorClass,
							children: [
								{
									title: "",
									className: backgroundColorClass,
									children: [
										{
											title: "申请机构名称",
											ellipsis: true,
											dataIndex: "HOSPITAL_NAME",
											width: '320px',
											align: "left",
											className: backgroundColorClass,
											render: (text) => {
												//生成序号
												return <span>
													<Tooltip title={text}>
														{text}
													</Tooltip>
												</span>;
											},
										},
									]
								},
							],
						}
					} else {

						packageColumns[0] = {
							title: "",
							className: backgroundColorClass,
							children: [
								{
									title: "",
									className: backgroundColorClass,
									children: [
										{
											title: "报告医生",
											ellipsis: true,
											dataIndex: 'REAL_NAME',
											width: '120px',
											align: "center",
											className: backgroundColorClass,
										},
									]
								},
							],
						}
					}
					this.setState({
						packageColumns
					})
				}

				if (this.state.institutionOrPerson === 0) {
					this.setState({
						packageHospitalData: data,
						isLoading: false,
						isFixedHeJiTaoCan: data.length > 12 ? true : false,
					})
				} else {
					this.setState({
						packagePersonData: data,
						isLoading: false,
						isFixedHeJiTaoCan: data.length > 12 ? true : false,
					})
				}
			} else {
				requestErrorLog('', '综合查询-统计报表-套餐检查量获取检查项目数据报错', 0, true)
				message.warn('获取检查项目失败')
				this.setState({
					isLoading: false
				})
			}
		}


	}
	//基础数据
	allBasicData = () => {
		getTypicalCasesBaseInfo().then((res) => {
			let basicsdata = []
			if (res && res.Status === 1) {
				basicsdata = res.Result.basicsdata
				for (let i = 0; i < basicsdata.length; i++) {
					if (basicsdata[i].name === "状态") {
						let reportStatus = basicsdata[i].dt;
						this.setState({
							reportStatus,
						});
					} else if (basicsdata[i].name === "会诊状态") {
						let consultationStatus = basicsdata[i].dt;
						this.setState({
							consultationStatus,
						});
					}

				}
			} else {
				requestErrorLog('', '综合查询-统计报表-获取基础数据报错', 0, true)
			}
		});
		let userInfo = JSON.parse(localStorage.getItem("userInfo"));
		if (!userInfo) return;
		let id = userInfo.HOSPITAL_UID;
		getExamItem(id).then((res) => {
			if (res && res.Status === 1) {
				let allData = []
				let checkType = []
				for (let i = 0; i < res.Result.length; i++) {
					if (res.Result[i].id === 'BloodPressure') {
						allData.push(res.Result[i])
						checkType.push({
							id: res.Result[i].id,
							name: res.Result[i].name,
						})
					}
					if (res.Result[i].id === 'ECG') {
						allData.push(res.Result[i])
						checkType.push({
							id: res.Result[i].id,
							name: res.Result[i].name,
						})
					}
					if (res.Result[i].id === 'Holter') {
						allData.push(res.Result[i])
						checkType.push({
							id: res.Result[i].id,
							name: res.Result[i].name,
						})
					}
				}
				this.setState({
					allData,
					checkType,
				})
			} else {
				requestErrorLog('', '综合查询-统计报表-获取检查项目报错', 0, true)
			}
		})
	};
	//选择检查类型
	changeCheckType = async (id) => {
		let checkSubclass = []
		if (id !== '') {
			let Param = {
				Type: "GetExam_SubList",
				EXAM_CLASS: id//检查类型
			}
			let res = await getGroupExamSubList(Param)
			if (res && res.Status === 1) {
				checkSubclass = res.Result ? res.Result : []
			} else {
				requestErrorLog('', '综合查询-统计报表-获取检查子类报错', 0, true)
			}

			this.setState({
				checkTypeID: id,
				checkSubclass,
				checkSubclassID: '',
				checkProjectID: '',
				checkProject: [],
			})
		}
		else {
			this.setState({
				checkTypeID: id,
				checkSubclass,
				checkProject: [],
				checkSubclassID: '',
				checkProjectID: '',
			})
		}
	}
	//选择检查子类
	changeCheckSubclass = async (id) => {
		let checkProject = []
		if (id !== '') {
			let Param = {
				Type: "GetExam_ItemList",
				EXAM_CLASS: this.state.checkTypeID,//检查类型
				EXAM_SUB: id?.split('&')[0] || ''//检查子类（自定义查询页面可不传）
			}
			let res = await getGroupExamItemList(Param)
			if (res && res.Status === 1) {
				checkProject = res.Result ? res.Result : []
			} else {
				requestErrorLog('', '综合查询-统计报表-获取检查项目报错', 0, true)
			}
			this.setState({
				checkProject,
				checkSubclassID: id,
				checkProjectID: '',
			})
		}
		else {
			this.setState({
				checkProject,
				checkSubclassID: id,
				checkProjectID: '',
			})
		}
	}
	//选择检查项目
	changeCheckProject = (id) => {
		this.setState({
			checkProjectID: id,
		})
	}
	//选择会诊状态
	consultationStatusChange = (id) => {
		this.setState({
			CONSULTATION_STATUS: id
		})
	}
	//选择报告状态
	reportStatusChange = (id) => {
		this.setState({
			EXAM_STATUS: id
		})
	}
	//选择开始时间
	setStartDate = (date) => {
		if (date) {
			this.setState({
				startDate: date,
			})
		} else {
			this.setState({
				startDate: '',
			})
		}
	}
	//选择结束时间
	setEndDate = (date) => {
		if (date) {
			this.setState({
				endDate: date,
			})
		} else {
			this.setState({
				endDate: '',
			})
		}
	}
	//转换列表
	turnInstitutionOrPerson = () => {
		this.setState({
			institutionOrPerson: this.state.institutionOrPerson === 0 ? 1 : 0,
			isLoading: true
		}, async () => {
			let packageColumns = await this.getPackageTableData('header');
			this.setState({
				packageColumns,
			}, () => {
				if (this.state.packageColumns.length > 0) {
					this.getPackageTableData('data');
				}
			})
		})
	}
	//勾选查询条件需要重新查表头以及表数据
	searchData = async () => {
		this.setState({ isLoading: true }, async () => {
			let packageColumns = await this.getPackageTableData('header');
			this.setState({
				packageColumns,
			}, () => {
				if (this.state.packageColumns.length > 0) {
					this.getPackageTableData('data');
				}
			})
		})
	}
	//导出
	exportPackageData = () => {
		//前端写导出
		let exportRowData1 = [], exportRowData2 = [], exportRowData3 = []
		let header = this.state.packageColumns//头部
		let columns = this.flattenArray(header)//表头扁平化
		let filename = this.state.institutionOrPerson === 0 ? '套餐检查量统计-机构' : '套餐检查量统计-个人'
		let data = this.state.institutionOrPerson === 0 ? this.state.packageHospitalData : this.state.packagePersonData
		let exportData = []//中间数据
		let nameList = [filename]
		let dateList = this.state.institutionOrPerson === 0 ? ['会诊机构：' + this.state.consultHospitalName] : ['申请机构：' + this.state.applyHospitalName]
		for (let a = 0; a < columns.length - 1; a++) {
			nameList.push('')
			dateList.push('')
		}
		exportData.push(nameList, dateList)
		for (let i = 0; i < header.length; i++) {//表头
			exportRowData1.push(header[i].title)//第一行表头
			let oneChildrenAtt = header[i].children
			if (oneChildrenAtt.length > 0) {//计算第一行、第二行合并内容
				let emptyTdArr1 = this.emptyTd(oneChildrenAtt)
				let row1 = emptyTdArr1.slice(0, -1)
				exportRowData1.push(...row1)
			}
			for (let j = 0; j < oneChildrenAtt.length; j++) {
				if (typeof (oneChildrenAtt[j].title) === 'function') {
					exportRowData2.push(oneChildrenAtt[j].titleSpare)//第二行表头
				}
				else {
					exportRowData2.push(oneChildrenAtt[j].title)//第二行表头
				}
				let twoChildrenAtt = oneChildrenAtt[j].children
				if (twoChildrenAtt.length > 1) {
					let emptyTdArr2 = this.emptyTd(twoChildrenAtt)
					let row2 = emptyTdArr2.slice(0, -1)
					exportRowData2.push(...row2)
				}
				for (let m = 0; m < twoChildrenAtt.length; m++) {
					if (typeof (twoChildrenAtt[m].title) === 'function') {
						exportRowData3.push(twoChildrenAtt[m].titleSpare)//第二行表头
					}
					else {
						exportRowData3.push(twoChildrenAtt[m].title)//第三行表头
					}
				}
			}
		}
		exportData.push(exportRowData1)
		exportData.push(exportRowData2)
		exportData.push(exportRowData3)
		//计算exportRowData1、exportRowData2合并内容
		let exportRowData1bingData = [], exportRowData2bingData = [], exportRowData1IsHeji = 0, exportRowData2IsHeji = 0

		for (let i = 0; i < exportRowData1.length; i++) {
			if (exportRowData1[i] !== '') {
				if (exportRowData1IsHeji === 0) {
					exportRowData1IsHeji = i
				} else {
					exportRowData1bingData.push({ s: { r: 2, c: exportRowData1IsHeji }, e: { r: 2, c: (i - 1) } })
					exportRowData1IsHeji = i
				}
			}
			if (i === exportRowData1.length - 1) {//最后一个合并
				if (exportRowData1[i] === '') {
					exportRowData1bingData.push({ s: { r: 2, c: exportRowData1IsHeji }, e: { r: 2, c: i } })
				}
			}
		}
		for (let i = 0; i < exportRowData2.length; i++) {
			if (exportRowData2[i] !== '') {
				if (exportRowData2IsHeji === 0) {
					exportRowData2IsHeji = i
				} else {
					exportRowData2bingData.push({ s: { r: 3, c: exportRowData2IsHeji }, e: { r: 3, c: (i - 1) } })
					exportRowData2IsHeji = i
				}
			}
			if (i === exportRowData2.length - 1) {//最后一个合并
				if (exportRowData2[i] === '') {
					exportRowData2bingData.push({ s: { r: 3, c: exportRowData2IsHeji }, e: { r: 3, c: i } })
				}
			}
		}


		for (let i = 0; i < data.length; i++) {//数据
			let everyRowData = []
			for (let j = 0; j < columns.length; j++) {
				if (data[i][columns[j].dataIndex] === undefined || data[i][columns[j].dataIndex] === null) {
					everyRowData.push('0')
				} else if (data[i][columns[j].dataIndex] === 0) {
					everyRowData.push('0')
				} else {
					everyRowData.push(data[i][columns[j].dataIndex])
				}

			}
			exportData.push(everyRowData)
		}
		exportData[exportData.length - 1][0] = '合计'
		//合并单元格的内容
		let mergesData = [
			{ s: { r: 0, c: 0 }, e: { r: 0, c: exportRowData2.length - 1 } }, // 第一行
			{ s: { r: 1, c: 0 }, e: { r: 1, c: exportRowData2.length - 1 } },// 第二行
			...exportRowData1bingData,// 第三行
			...exportRowData2bingData,// 第四行
		]
		if (this.state.institutionOrPerson === 0) {//机构合计要合并
			mergesData.push({ s: { r: exportData.length - 1, c: 0 }, e: { r: exportData.length - 1, c: 2 } })
		}

		exportExcelByData(exportData, filename + '.xlsx', mergesData)
	}
	//扁平化表头
	flattenArray = (arr) => {
		const result = [];
		function recurse(items) {
			items.forEach(item => {
				const { children, ...rest } = item;
				if (rest.dataIndex !== undefined) {
					result.push(rest);
				}
				if (children) {
					recurse(children);
				}
			});
		}
		recurse(arr);
		return result;
	}
	//计算合并行需要push几个空格
	emptyTd = (treeData) => {
		const emptyArr = []
		for (let i = 0; i < treeData.length; i++) {
			if (treeData[i].children) {//如果有子集
				for (let j = 0; j < treeData[i].children.length; j++) {
					emptyArr.push('')
				}
			} else {
				emptyArr.push('')
			}

		}
		return emptyArr
	}
	//开单量统计单独处理
	//一级分组变化
	firstGroupChangeBill = async (code) => {
		let codeBill = code
		let res = {}, clearSelect = {}
		let firstGroupNameBill = code.length > 0 ? this.state.firstGroupListBill.filter(item => code.indexOf(item.FIRST_GROUP_CODE) > -1).map((item) => { return item.FIRST_GROUP_NAME }) : ''
		clearSelect = {
			firstGroupNameBill,
			firstGroupValueBill: code,
			secondGroupListBill: [],
			secondGroupNameBill: '',
			secondGroupValueBill: [],
			billDoctorValue: '',
			billDoctorList: [],
			billHospitalCode: this.state.isStystemOrSupervise ? '' : this.state.billHospitalCode,
			billApplyHospitalList: [],
		}
		//二次需求：一级分组为空也请求二级分组列表；单纯处理医生开单量
		if (!code.length > 0) {
			code = this.state.firstGroupListBill.map(obj => obj.FIRST_GROUP_CODE)
		}
		res = await getSearchPartSecondData("E00113", this.state.userInfo.HOSPITAL_CODE, code.toString())
		if (res && res.Status === 1) {
			let secondGroupListBill = res.Result ? res.Result : []
			if (!code.length > 0) {
				secondGroupListBill = uniqueJsonArrByField(secondGroupListBill, 'SECOND_GROUP_NAME')
			} else {
				requestErrorLog('', '综合查询-统计报表-获取开单量统计二级分组报错', 0, true)
			}
			clearSelect.secondGroupListBill = secondGroupListBill
		}
		//分组1勾选时，给分组二的全选框赋空
		let indeterminateSecondBill = false;
		let selectSecondAllStateBill = false;
		let indeterminateFirstBill = false;
		let selectFirstAllStateBill = false;
		//选中的数据不等于全选的数据长度，全选框为半选状态
		if (codeBill.length > 0 && codeBill.length < this.state.firstGroupListBill.length) {
			indeterminateFirstBill = true
		} else {
			if (codeBill.length === this.state.firstGroupListBill.length) {
				selectFirstAllStateBill = true
			}
		}

		this.setState({
			billMonthDisabled: false,
			indeterminateSecondBill,
			selectSecondAllStateBill,
			indeterminateFirstBill,
			selectFirstAllStateBill,
			...clearSelect
		})
	}
	//二级分组变化
	secondGroupChangeBill = async (code) => {//二次需求：一级分组为空也请求二级分组列表；
		if (this.state.firstGroupValueBill.length > 0) {
			let clearSelect = {}
			let secondGroupNameBill = code.length > 0 ? this.state.secondGroupListBill.filter(item => code.indexOf(item.SECOND_GROUP_CODE) > -1).map((item) => { return item.SECOND_GROUP_NAME }) : ''
			clearSelect = {
				secondGroupNameBill,
				secondGroupValueBill: code,
				billDoctorValue: '',
				billDoctorList: [],
				billHospitalCode: this.state.isStystemOrSupervise ? '' : this.state.billHospitalCode,
				billApplyHospitalList: [],
			}
			if (code.length > 0) {
				if (!this.state.isStystemOrSupervise) {
					this.initBillDoctorList(this.state.billHospitalCode);//获取开单量统计开单医生列表
				}
			}
			if (localStorage.getItem("statisticalType") === '申请医院' && !this.state.isStystemOrSupervise) {
				clearSelect.billApplyHospitalList = [{
					APPLY_HOSPITAL_CODE: this.state.userInfo.HOSPITAL_CODE,
					APPLY_HOSPITAL_NAME: this.state.userInfo.HOSPITAL_NAME
				}]
			} else {
				clearSelect.billApplyHospitalList = await this.initBillHospitalList(this.state.firstGroupValueBill, code)
			}
			this.setState({
				billMonthDisabled: false,
				...clearSelect,
			})
		} else {
			let secondGroupNameBill = code.length > 0 ? this.state.secondGroupListBill.filter(item => code.indexOf(item.SECOND_GROUP_CODE) > -1).map((item) => { return item.SECOND_GROUP_NAME }) : ''
			this.setState({
				secondGroupValueBill: code,
				secondGroupNameBill: code.length > 0 ? secondGroupNameBill : '',
			})
		}

		//分组1勾选时，给分组二的全选框赋空
		let indeterminateSecondBill = false;
		let selectSecondAllStateBill = false;
		//选中的数据不等于全选的数据长度，全选框为半选状态
		if (code.length > 0 && code.length < this.state.secondGroupListBill.length) {
			indeterminateSecondBill = true
		} else {
			if (code.length === this.state.secondGroupListBill.length) {
				selectSecondAllStateBill = true
			}
		}
		this.setState({
			indeterminateSecondBill,
			selectSecondAllStateBill
		})

	}
	examSearchTypeChange = (value) => {
		this.setState({
			examSearchTypeValue: value
		})
	}
	checkSearchTypeChange = (value) => {
		this.setState({
			checkSearchTypeValue: value
		})
	}
	onClose = () => {
		this.setState({
			drawerShow: false
		})
	}
	tableOnClick = (record) => {//右键
		if (record.APPLY_HOSPITAL_NAME === '合计' || record.APPLY_HOSPITAL_NAME === '总计') {
			return
		}
		if (!record.APPLY_HOSPITAL_CODE) {
			return
		}
		this.setState({
			drawerShow: true,
			rightClickRecord: record
		})
	}

	handleFirstChange = (e) => {
		let firstGroupValue = []
		if (e.target.checked) {//取做所有一级分组值赋给一级分组
			firstGroupValue = this.state.firstGroupList ? this.state.firstGroupList?.map((item) => item.FIRST_GROUP_CODE) : []
		}
		this.firstGroupChange(firstGroupValue)
	}
	handleSecondChange = (e) => {
		let secondGroupValue = []
		if (e.target.checked) {//取做所有一级分组值赋给一级分组
			secondGroupValue = this.state.secondGroupList ? this.state.secondGroupList?.map((item) => item.SECOND_GROUP_CODE) : []
		}
		this.secondGroupChange(secondGroupValue)
	}

	handleFirstChangeBill = (e) => {
		let firstGroupValueBill = []
		if (e.target.checked) {//取做所有一级分组值赋给一级分组
			firstGroupValueBill = this.state.firstGroupListBill ? this.state.firstGroupListBill?.map((item) => item.FIRST_GROUP_CODE) : []
		}
		this.firstGroupChangeBill(firstGroupValueBill)
	}
	handleSecondChangeBill = (e) => {
		let secondGroupValueBill = []
		if (e.target.checked) {//取做所有一级分组值赋给一级分组
			secondGroupValueBill = this.state.secondGroupListBill ? this.state.secondGroupListBill?.map((item) => item.SECOND_GROUP_CODE) : []
		}
		this.secondGroupChangeBill(secondGroupValueBill)
	}
	render() {
		const {
			dataList,
			doctorWorkList,
			billDoctorWorkList,
			showKey,
			paintModalShow,
			startValue,
			startOpen,
			endValue,
			billValue,
			billOpen,
			endOpen,
			consultHospitalList,
			applyHospitalList,
			billApplyHospitalList,
			billDoctorList,
			monthList,
			consultationStatus,
			reportStatus,
			checkType,
			checkSubclass,
			checkProject,
			checkSubclassID,
			checkProjectID,
			checkTypeID,
			packageColumns,
			institutionOrPerson,
			searchTime,
			packageHospitalData,
			packagePersonData,
			firstGroupList,
			secondGroupList,
			firstGroupValue,
			secondGroupValue,
			isStystemOrSupervise,
			firstGroupName,
			secondGroupName,
			firstGroupListBill,//一级分组列表
			secondGroupListBill,//一级分组列表
			firstGroupValueBill,
			secondGroupValueBill,
			firstGroupNameBill,
			secondGroupNameBill,
		} = this.state;
		const doctorColumns = [
			{
				title: "",
				ellipsis: true,
				width: 200,
				children: [
					{
						title: "一级分组",
						dataIndex: "FIRST_GROUP_NAME",
						key: "FIRST_GROUP_NAME",
						ellipsis: true,
						width: this.state.consultHospitalName ? 0 : 120,
						align: "left",
					},
				],
			},
			{
				title: "",
				ellipsis: true,
				width: 240,
				children: [
					{
						title: "二级分组",
						dataIndex: "SECOND_GROUP_NAME",
						key: "SECOND_GROUP_NAME",
						ellipsis: true,
						width: this.state.consultHospitalName ? 0 : 240,
						align: "left",
					},
				],
			},
			{
				title: "",
				ellipsis: true,
				width: 200,
				children: [
					{
						title: "会诊机构",
						dataIndex: "CONSULTATION_HOSPITAL_NAME",
						key: "CONSULTATION_HOSPITAL_NAME",
						ellipsis: true,
						width: this.state.consultHospitalName ? 0 : 320,
						align: "left",
					},
				],
			},
			{
				title: "",
				ellipsis: true,
				width: 200,
				children: [
					{
						title: this.state.selectdoctorName ? "月份" : "姓名",
						dataIndex: "CONSULTATION_DOCTOR_NAME",
						key: "CONSULTATION_DOCTOR_NAME",
						ellipsis: true,
						width: 200,
						align: "center",
					},
				],
			},
			{
				title: "病例会诊量",
				children: [
					{
						title: "动态心电",
						dataIndex: "HOLTER_Consulation_Sum",
						key: "HOLTER_Consulation_Sum",
						align: "center",
					},
					{
						title: "动态血压",
						dataIndex: "BP_Consulation_Sum",
						key: "BP_Consulation_Sum",
						align: "center",
					},
					{
						title: "静息心电",
						dataIndex: "ECG_Consulation_Sum",
						key: "ECG_Consulation_Sum",
						align: "center",
					},
					{
						title: "合计",
						dataIndex: "Consulation_Total",
						key: "Consulation_Total",
						align: "center",
					},
				],
			},
			{
				title: "病例退回量",
				children: [
					{
						title: "动态心电",
						dataIndex: "HOLTER_Exit_Sum",
						key: "HOLTER_Exit_Sum",
						align: "center",
					},
					{
						title: "动态血压",
						dataIndex: "BP_Exit_Sum",
						key: "BP_Exit_Sum",
						align: "center",
					},
					{
						title: "静息心电",
						dataIndex: "ECG_Exit_Sum",
						key: "ECG_Exit_Sum",
						align: "center",
					},
					{
						title: "合计",
						dataIndex: "Exit_Total",
						key: "Exit_Total",
						align: "center",
					},
				],
			},
		];
		const billDoctorColumns = [
			{
				title: "一级分组",
				dataIndex: "FIRST_GROUP_NAME",
				key: "FIRST_GROUP_NAME",
				ellipsis: true,
				width: this.state.billHospitalCodeName ? 0 : 120,
				align: "left",
			},
			{
				title: "二级分组",
				dataIndex: "SECOND_GROUP_NAME",
				key: "SECOND_GROUP_NAME",
				ellipsis: true,
				width: this.state.billHospitalCodeName ? 0 : 240,
				align: "left",
			},
			{
				title: "申请机构",
				dataIndex: "APPLY_HOSPITAL_NAME",
				key: "APPLY_HOSPITAL_NAME",
				ellipsis: true,
				width: this.state.billHospitalCodeName ? 0 : 320,
				align: "left",
			},
			{
				title: this.state.selectBillDoctorName ? "月份" : "姓名",
				dataIndex: "BILLING_DOCTOR",
				key: "BILLING_DOCTOR",
				ellipsis: true,
				width: 200,
				align: "center",
			},
			{
				title: "动态心电",
				dataIndex: "HOLTER_Sum",
				key: "HOLTER_Sum",
				align: "center",
			},
			{
				title: "动态血压",
				dataIndex: "BP_Sum",
				key: "BP_Sum",
				align: "center",
			},
			{
				title: "静息心电",
				dataIndex: "ECG_Sum",
				key: "ECG_Sum",
				align: "center",
			},
			{
				title: "合计",
				dataIndex: "Total",
				key: "Total",
				align: "center",
			},
		];
		let firstGroupLength = '+' + firstGroupValue?.length.toString();
		let secondGroupLength = '+' + secondGroupValue?.length.toString();

		let firstGroupLengthBill = '+' + firstGroupValueBill?.length.toString();
		let secondGroupLengthBill = '+' + secondGroupValueBill?.length.toString();
		return (
			<div style={{ display: "flex", height: "100%" }}>
				<QueryLeft />
				<div className="eleWrap applyTd statisticsTable" style={{ flex: 1 }}>
					<Tabs
						defaultActiveKey={this.state.showKey}
						type="card"
						onChange={this.handleTabKey}>
						<TabPane key="1" tab={<p className="badgeText">会诊量统计</p>}>
							<div className="commonCase">
								<div className="datePickerBox" style={{ flexWrap: 'wrap' }}>
									<div className="wrapDiv">
										<span>查询年度：</span>
										<DatePicker
											mode="year"
											placeholder="请选择查询年度"
											format="YYYY"
											value={startValue}
											open={startOpen}
											allowClear={false}
											onOpenChange={this.handleStartOpenChange}
											onPanelChange={this.handleStartPanelChange}
										/>
										<span className="institution">查询月份：</span>
										<Select
											value={this.state.consultationMonth}
											onChange={this.changeConsultationMonth}
											disabled={this.state.consultationMonthDisabled}>
											<Option value="">全部</Option>
											{monthList.map((item) => (
												<Option key={item.key + item.value} value={item.key}>
													{item.value}
												</Option>
											))}
										</Select>
										<span className="institution">病例类型：</span>
										<CheckboxGroup
											options={this.state.examSearchType}
											onChange={this.examSearchTypeChange}
											defaultValue={this.state.examSearchTypeValue}
											value={this.state.examSearchTypeValue}
										></CheckboxGroup>
										<span className="institution" style={{ marginLeft: '50px' }}>检查类型：</span>
										<CheckboxGroup
											options={this.state.checkSearchType}
											onChange={this.checkSearchTypeChange}
											defaultValue={this.state.checkSearchTypeValue}
											value={this.state.checkSearchTypeValue}
										></CheckboxGroup>
									</div>
									<div className="wrapDiv">
										<span>一级分组：</span>
										<Tooltip overlayClassName='tooltipColor' title={firstGroupName.toString()}>
											<Select
												className='noWrapSelect'
												mode="multiple"
												value={firstGroupValue}
												allowClear
												showSearch
												optionFilterProp="children"
												maxTagCount={1}
												maxTagPlaceholder={firstGroupLength}
												maxTagTextLength={4}
												onChange={this.firstGroupChange}
												dropdownRender={(allSelectValue) => (
													<div>
														<div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }} onMouseDown={e => e.preventDefault()}>
															<Checkbox
																checked={this.state.selectFirstAllState}
																onChange={this.handleFirstChange}
																indeterminate={this.state.indeterminateFirst}
															>
															</Checkbox>
															&nbsp;&nbsp;全选
														</div>
														<Divider style={{ margin: "0" }} />
														{allSelectValue}
													</div>
												)}
											>
												{firstGroupList.map((item, index) => (
													<Option key={index + item.FIRST_GROUP_CODE} value={item.FIRST_GROUP_CODE}>
														{item.FIRST_GROUP_NAME}
													</Option>
												))}
											</Select>
										</Tooltip>
										<span className="institution">二级分组：</span>
										<Tooltip overlayClassName='tooltipColor' title={secondGroupName.toString()}>
											<Select
												className='noWrapSelect'
												mode="multiple"
												value={secondGroupValue}
												allowClear
												showSearch
												optionFilterProp="children"
												maxTagCount={1}
												maxTagPlaceholder={secondGroupLength}
												maxTagTextLength={4}
												onChange={this.secondGroupChange}

												dropdownRender={(allSelectValue) => (
													<div>
														<div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }} onMouseDown={e => e.preventDefault()}>
															<Checkbox
																checked={this.state.selectSecondAllState}
																onChange={this.handleSecondChange}
																indeterminate={this.state.indeterminateSecond}
															>
															</Checkbox>
															&nbsp;&nbsp;全选
														</div>
														<Divider style={{ margin: "0" }} />
														{allSelectValue}
													</div>
												)}
											>
												{secondGroupList.map((item, index) => (
													<Option key={index + item.SECOND_GROUP_CODE} value={item.SECOND_GROUP_CODE}>
														{item.SECOND_GROUP_NAME}
													</Option>
												))}
											</Select>
										</Tooltip>
										<span className="institution">会诊机构：</span>
										<Select
											value={this.state.consultHospitalValue}
											onChange={this.consultHospitalChange}
											disabled={
												!isStystemOrSupervise
											}
											showSearch
											optionFilterProp="children">
											<Option value="">全部</Option>
											{consultHospitalList
												? consultHospitalList.map((item) => (
													<Option
														key={item.HOSPITAL_CODE + item.HOSPITAL_NAME}
														value={item.HOSPITAL_CODE}>
														{item.HOSPITAL_NAME}
													</Option>
												))
												: null}
										</Select>
										<span className="institution">申请机构：</span>
										<Select
											value={this.state.applyHospitalValue}
											onChange={this.applyHospitalChange}
											showSearch
											optionFilterProp="children">
											<Option value="">全部</Option>
											{applyHospitalList.map((item) => (
												<Option
													key={
														item.APPLY_HOSPITAL_CODE + item.APPLY_HOSPITAL_NAME
													}
													value={item.APPLY_HOSPITAL_CODE}>
													{item.APPLY_HOSPITAL_NAME}
												</Option>
											))}
										</Select>
										<Button loading={this.state.isLoadingData} onClick={this.getDataList}>查询</Button>
										<Button loading={this.state.isLoadingExportData} onClick={this.exportConsultationVolume}>导出</Button>
										<Button
											onClick={() => {
												this.setState({
													paintModalShow: true,
												});
											}}>
											打印
										</Button>
									</div>
								</div>
							</div>
							<div className="statisticsTableBox" id="replacePackageStatisticsTableBox"
								style={{ maxWidth: this.state.defauleTableWidth }}
							>
								<Spin size="large" spinning={this.state.isLoadingData} tip="Loading...">
									<Table
										id='tableDIV'
										columns={this.state.columns}
										dataSource={this.state.dataList}
										bordered
										rowKey={(record, index) =>
											record.APPLY_HOSPITAL_NAME + record.APPLY_HOSPITAL_CODE + index
										} // 需要修改为唯一的ID！
										pagination={false}
										rowClassName={this.state.isFixedHeJiHuiZhen ? fixedTotal : () => { }}
										scroll={{
											y: 600,
											x: 120,
										}}
										onRow={(record) => {
											return {
												onContextMenu: (e) => {
													this.tableOnClick(record);
												},
											};
										}}
										title={() => (
											<div className="tableHeader">
												<p>会诊机构：{this.state.consultHospitalName}</p>
												{this.state.applyHospitalName ? (
													<p>申请机构：{this.state.applyHospitalName}</p>
												) : null}
												<p>
													查询年度：{this.state.selectStartValue}{" "}
													{this.state.selectConsultationMonth
														? " - " + this.state.selectConsultationMonth
														: ""}
												</p>
											</div>
										)}>

									</Table>
								</Spin>
							</div>
						</TabPane>

						<TabPane key="2" tab={<p className="badgeText">医生工作量统计</p>}>
							<div className="commonCase">
								<div className="datePickerBox" style={{ flexWrap: 'wrap' }}>
									<div className="wrapDiv">
										<span>查询年度：</span>
										<DatePicker
											mode="year"
											placeholder="请选择查询年度"
											format="YYYY"
											value={endValue}
											open={endOpen}
											allowClear={false}
											onOpenChange={this.handleEndOpenChange}
											onPanelChange={this.handleEndPanelChange}
										/>
										<span className="institution">查询月份：</span>
										<Select
											value={this.state.doctorMonth}
											onChange={this.changeDoctorMonth}
											disabled={this.state.doctorMonthDisabled}>
											<Option value="">全部</Option>
											{monthList.map((item) => (
												<Option key={item.key + item.value} value={item.key}>
													{item.value}
												</Option>
											))}
										</Select>
									</div>
									<div className="wrapDiv">
										<span>一级分组：</span>
										<Tooltip overlayClassName='tooltipColor' title={firstGroupName.toString()}>
											<Select
												mode="multiple"
												value={firstGroupValue}
												showSearch
												optionFilterProp="children"
												allowClear
												className='noWrapSelect'
												maxTagCount={1}
												maxTagPlaceholder={firstGroupLength}
												maxTagTextLength={4}
												onChange={this.firstGroupChange}

												dropdownRender={(allSelectValue) => (
													<div>
														<div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }} onMouseDown={e => e.preventDefault()}>
															<Checkbox
																checked={this.state.selectFirstAllState}
																onChange={this.handleFirstChange}
																indeterminate={this.state.indeterminateFirst}
															>
															</Checkbox>
															&nbsp;&nbsp;全选
														</div>
														<Divider style={{ margin: "0" }} />
														{allSelectValue}
													</div>
												)}
											>
												{firstGroupList.map((item, index) => (
													<Option key={index + item.FIRST_GROUP_CODE} value={item.FIRST_GROUP_CODE}>
														{item.FIRST_GROUP_NAME}
													</Option>
												))}
											</Select>
										</Tooltip>
										<span className="institution">二级分组：</span>
										<Tooltip overlayClassName='tooltipColor' title={secondGroupName.toString()}>
											<Select
												className='noWrapSelect'
												showSearch
												optionFilterProp="children"
												allowClear
												maxTagCount={1}
												maxTagPlaceholder={secondGroupLength}
												maxTagTextLength={4}
												mode="multiple"
												value={secondGroupValue}
												onChange={this.secondGroupChange}

												dropdownRender={(allSelectValue) => (
													<div>
														<div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }} onMouseDown={e => e.preventDefault()}>
															<Checkbox
																checked={this.state.selectSecondAllState}
																onChange={this.handleSecondChange}
																indeterminate={this.state.indeterminateSecond}
															>
															</Checkbox>
															&nbsp;&nbsp;全选
														</div>
														<Divider style={{ margin: "0" }} />
														{allSelectValue}
													</div>
												)}
											>
												{secondGroupList.map((item, index) => (
													<Option key={index + item.SECOND_GROUP_CODE} value={item.SECOND_GROUP_CODE}>
														{item.SECOND_GROUP_NAME}
													</Option>
												))}
											</Select>
										</Tooltip>
										<span className="institution">机构名称：</span>
										<Select
											value={this.state.consultHospitalValue}
											onChange={this.consultHospitalChange}
											disabled={
												!isStystemOrSupervise
											}
											showSearch
											optionFilterProp="children">
											<Option value="">全部</Option>
											{consultHospitalList
												? consultHospitalList.map((item) => (
													<Option
														key={item.HOSPITAL_CODE}
														value={item.HOSPITAL_CODE}>
														{item.HOSPITAL_NAME}
													</Option>
												))
												: null}
										</Select>
										<span className="institution">会诊人：</span>
										<Select
											value={this.state.doctorValue}
											onChange={this.doctorChange}>
											<Option value="">全部</Option>
											{this.state.doctorList.map((item) => (
												<Option
													key={item.USER_UID + '&' + item.REAL_NAME}
													value={item.USER_UID + '&' + item.REAL_NAME}>
													{item.REAL_NAME}
												</Option>
											))}
										</Select>
										<Button onClick={this.getDoctorWorkload} loading={this.state.isLoadingDoctor}>查询</Button>
										<Button onClick={this.exportDoctorWorkload} loading={this.state.isLoadingExportDoctor}>导出</Button>
										<Button
											onClick={() => {
												this.setState({
													paintModalShow: true,
												});
											}}>
											打印
										</Button>
									</div>
								</div>
							</div>
							<div className="statisticsTableBox">
								<Spin size="large" spinning={this.state.isLoadingDoctor} tip="Loading...">
									<Table
										columns={doctorColumns}
										dataSource={this.state.doctorWorkList}
										rowClassName={this.state.isFixedHeJiYiSheng ? fixedTotal : () => { }}
										bordered
										pagination={false}
										rowKey={(record, index) =>
											record.CONSULTATION_DOCTOR_NAME + index
										} // 需要修改为唯一的ID！
										scroll={{ y: 600 }}
										title={() => (
											<div className="tableHeader">
												{this.state.selectdoctorName ? (
													<p>姓名：{this.state.selectdoctorName}</p>
												) : null}
												<p>隶属机构：{this.state.consultHospitalName}</p>
												<p>
													统计年度：{this.state.selectEndValue}
													{this.state.selectDoctorMonth
														? " - " + this.state.selectDoctorMonth
														: ""}
												</p>
											</div>
										)}></Table>
								</Spin>
							</div>
						</TabPane>

						<TabPane key="3" tab={<p className="badgeText">开单量统计</p>}>
							<div className="commonCase">
								<div className="datePickerBox" style={{ flexWrap: 'wrap' }}>
									<div className="wrapDiv">
										<span>查询年度：</span>
										<DatePicker
											mode="year"
											placeholder="请选择查询年度"
											format="YYYY"
											value={billValue}
											open={billOpen}
											allowClear={false}
											showSearch
											onOpenChange={this.handleBillOpenChange}
											onPanelChange={this.handleBillPanelChange}
										/>
										<span className="institution">查询月份：</span>
										<Select
											value={this.state.billMonth}
											onChange={this.changeBillMonth}
											disabled={this.state.billMonthDisabled}>
											<Option value="">全部</Option>
											{monthList.map((item) => (
												<Option key={item.key + item.key} value={item.key}>
													{item.value}
												</Option>
											))}
										</Select>
									</div>
									<div className="wrapDiv">
										<span>一级分组：</span>
										<Tooltip overlayClassName='tooltipColor' title={firstGroupNameBill.toString()}>

											<Select
												className='noWrapSelect'
												mode="multiple"
												value={firstGroupValueBill}
												allowClear
												showSearch
												optionFilterProp="children"
												maxTagCount={1}
												maxTagPlaceholder={firstGroupLengthBill}
												maxTagTextLength={4}
												onChange={this.firstGroupChangeBill}
												dropdownRender={(allSelectValue) => (
													<div>
														<div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }} onMouseDown={e => e.preventDefault()}>
															<Checkbox
																checked={this.state.selectFirstAllStateBill}
																onChange={this.handleFirstChangeBill}
																indeterminate={this.state.indeterminateFirstBill}
															>
															</Checkbox>
															&nbsp;&nbsp;全选
														</div>
														<Divider style={{ margin: "0" }} />
														{allSelectValue}
													</div>
												)}
											>
												{firstGroupListBill.map((item, index) => (
													<Option key={index + item.FIRST_GROUP_CODE} value={item.FIRST_GROUP_CODE}>
														{item.FIRST_GROUP_NAME}
													</Option>
												))}
											</Select>
										</Tooltip>
										<span className="institution">二级分组：</span>
										<Tooltip overlayClassName='tooltipColor' title={secondGroupNameBill.toString()}>
											<Select
												className='noWrapSelect'
												mode="multiple"
												value={secondGroupValueBill}
												allowClear
												showSearch
												optionFilterProp="children"
												maxTagCount={1}
												maxTagPlaceholder={secondGroupLengthBill}
												maxTagTextLength={4}
												onChange={this.secondGroupChangeBill}

												dropdownRender={(allSelectValue) => (
													<div>
														<div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }} onMouseDown={e => e.preventDefault()}>
															<Checkbox
																checked={this.state.selectSecondAllStateBill}
																onChange={this.handleSecondChangeBill}
																indeterminate={this.state.indeterminateSecondBill}
															>
															</Checkbox>
															&nbsp;&nbsp;全选
														</div>
														<Divider style={{ margin: "0" }} />
														{allSelectValue}
													</div>
												)}
											>
												{secondGroupListBill.map((item, index) => (
													<Option key={index + item.SECOND_GROUP_CODE} value={item.SECOND_GROUP_CODE}>
														{item.SECOND_GROUP_NAME}
													</Option>
												))}
											</Select>
										</Tooltip>
										<span className="institution">机构名称：</span>
										<Select
											value={this.state.billHospitalCode}
											onChange={this.handleBillHospitalValue}
											disabled={!isStystemOrSupervise}
											showSearch
											optionFilterProp="children">
											<Option value="">全部</Option>
											{billApplyHospitalList.map((item) => (
												<Option
													key={
														item.APPLY_HOSPITAL_CODE + item.APPLY_HOSPITAL_NAME
													}
													value={item.APPLY_HOSPITAL_CODE}>
													{item.APPLY_HOSPITAL_NAME}
												</Option>
											))}
										</Select>
										<span className="institution">开单医生：</span>
										<Select
											value={this.state.billDoctorValue}
											onChange={this.billDoctorChange}>
											<Option value="">全部</Option>
											{billDoctorList.map((item, index) => (
												<Option
													key={item.BILLING_DOCTOR + '&' + index}
													value={item.BILLING_DOCTOR + '&' + index}>
													{item.BILLING_DOCTOR}
												</Option>
											))}
										</Select>
										<Button onClick={this.getBillDoctorWorkload} loading={this.state.isLoadingBill} >查询</Button>
										<Button onClick={this.exportBillDoctorWorkload} loading={this.state.isLoadingExportBill}>导出</Button>
										<Button
											onClick={() => {
												this.setState({
													paintModalShow: true,
												});
											}}>
											打印
										</Button>
									</div>
								</div>
							</div>
							<div className="statisticsTableBox">
								<Spin size="large" spinning={this.state.isLoadingBill} tip="Loading...">
									<Table
										columns={billDoctorColumns}
										dataSource={this.state.billDoctorWorkList}
										bordered
										pagination={false}
										scroll={{ y: 600 }}
										rowClassName={this.state.isFixedHeJiKaiDan ? fixedTotal : () => { }}
										rowKey={(record, index) =>
											record.BILLING_DOCTOR + record.APPLY_HOSPITAL_NAME + index
										} // 需要修改为唯一的ID！
										title={() => (
											<div className="tableHeader">
												{this.state.selectBillDoctorName ? (
													<p>姓名：{this.state.selectBillDoctorName}</p>
												) : null}
												<p>隶属机构：{this.state.billHospitalName}</p>
												<p>
													统计年度：{this.state.selectEndValue}
													{this.state.selectBillMonth
														? " - " + this.state.selectBillMonth
														: ""}
												</p>
											</div>
										)}></Table>
								</Spin>
							</div>
						</TabPane>

						<TabPane key="4" tab={<p className="badgeText">套餐检查量统计</p>}>
							<div className="commonCase">
								<div className="datePickerBox" style={{ flexWrap: 'wrap' }}>
									<div className="wrapDiv">
										<span>检查时间：</span>
										<DatePicker
											style={{ width: 125 }}
											placeholder='开始日期'
											onChange={this.setStartDate}
											defaultValue={this.state.startDate}
											allowClear={false}
										/>
										<span style={{ display: 'inline-block', textAlign: 'center', width: 15 }}>-</span>
										<DatePicker
											style={{ width: 125 }}
											placeholder='结束日期'
											onChange={this.setEndDate}
											defaultValue={this.state.endDate}
											allowClear={false}
										/>
										<span className="institution">会诊状态：</span>
										<Select defaultValue={""} onChange={this.consultationStatusChange}>
											<Option value="">全部</Option>
											{consultationStatus.map((item) => (
												<Option key={item.DIC_CODE} value={item.DIC_CODE}>
													{item.DIC_NAME}
												</Option>
											))}
										</Select>
										<span className="institution">报告状态：</span>
										<Select defaultValue={""} onChange={this.reportStatusChange}>
											<Option value="">全部</Option>
											{reportStatus.map((item) => (
												<Option key={item.DIC_CODE} value={item.DIC_CODE}>
													{item.DIC_NAME}
												</Option>
											))}
										</Select>
										<span className="institution">一级分组：</span>

										<Tooltip overlayClassName='tooltipColor' title={firstGroupName.toString()}>
											<Select
												className='noWrapSelect'
												mode="multiple"
												value={firstGroupValue}
												allowClear
												showSearch
												optionFilterProp="children"
												maxTagCount={1}
												maxTagPlaceholder={firstGroupLength}
												maxTagTextLength={4}
												onChange={this.firstGroupChange}

												dropdownRender={(allSelectValue) => (
													<div>
														<div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }} onMouseDown={e => e.preventDefault()}>
															<Checkbox
																checked={this.state.selectFirstAllState}
																onChange={this.handleFirstChange}
																indeterminate={this.state.indeterminateFirst}
															>
															</Checkbox>
															&nbsp;&nbsp;全选
														</div>
														<Divider style={{ margin: "0" }} />
														{allSelectValue}
													</div>
												)}
											>
												{firstGroupList.map((item, index) => (
													<Option key={index + item.FIRST_GROUP_CODE} value={item.FIRST_GROUP_CODE}>
														{item.FIRST_GROUP_NAME}
													</Option>
												))}
											</Select>
										</Tooltip>
										<span className="institution">二级分组：</span>
										<Tooltip overlayClassName='tooltipColor' title={secondGroupName.toString()}>
											<Select
												className='noWrapSelect'
												mode="multiple"
												value={secondGroupValue}
												allowClear
												showSearch
												optionFilterProp="children"
												maxTagCount={1}
												maxTagPlaceholder={secondGroupLength}
												maxTagTextLength={4}
												onChange={this.secondGroupChange}
												dropdownRender={(allSelectValue) => (
													<div>
														<div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }} onMouseDown={e => e.preventDefault()}>
															<Checkbox
																checked={this.state.selectSecondAllState}
																onChange={this.handleSecondChange}
																indeterminate={this.state.indeterminateSecond}
															>
															</Checkbox>
															&nbsp;&nbsp;全选
														</div>
														<Divider style={{ margin: "0" }} />
														{allSelectValue}
													</div>
												)}
											>
												{secondGroupList.map((item, index) => (
													<Option key={index + item.SECOND_GROUP_CODE} value={item.SECOND_GROUP_CODE}>
														{item.SECOND_GROUP_NAME}
													</Option>
												))}
											</Select>
										</Tooltip>
									</div>
									<div className="wrapDiv">
										<span>会诊机构：</span>
										<Select
											value={this.state.consultHospitalValue}
											onChange={this.consultHospitalChange}
											disabled={
												!isStystemOrSupervise
											}
											showSearch
											optionFilterProp="children">
											{consultHospitalList
												? consultHospitalList.map((item) => (
													<Option
														key={item.HOSPITAL_CODE + item.HOSPITAL_NAME}
														value={item.HOSPITAL_CODE}>
														{item.HOSPITAL_NAME}
													</Option>
												))
												: null}
										</Select>
										<span className="institution">申请机构：</span>
										<Select
											value={this.state.applyHospitalValue}
											onChange={this.applyHospitalChange}
											showSearch
											optionFilterProp="children">
											<Option value="">全部</Option>
											{applyHospitalList.map((item) => (
												<Option
													key={
														item.APPLY_HOSPITAL_CODE + item.APPLY_HOSPITAL_NAME
													}
													value={item.APPLY_HOSPITAL_CODE}>
													{item.APPLY_HOSPITAL_NAME}
												</Option>
											))}
										</Select>
										<span className="institution">检查类型：</span>
										<Select onChange={this.changeCheckType}
											value={
												checkTypeID ? checkTypeID : ''
											}>
											<Option value="">全部</Option>
											{checkType.map((item) => (
												<Option key={item.id} value={item.id}>
													{item.name}
												</Option>
											))}
										</Select>
										<span className="institution">检查子类：</span>
										<Select onChange={this.changeCheckSubclass}
											value={
												checkSubclassID ? checkSubclassID : ''
											}
										>
											<Option value="">全部</Option>
											{checkSubclass.map((item, index) => (
												<Option key={item.SUB_CLASS_CODE + '&' + index} value={item.SUB_CLASS_CODE + '&' + index}>
													{item.SUB_CLASS_NAME}
												</Option>
											))}
										</Select>
										<span className="institution">检查项目：</span>
										<Select value={
											checkProjectID ? checkProjectID : ''
										}
											onChange={this.changeCheckProject}>
											<Option value="">全部</Option>
											{checkProject.map((item, index) => (
												<Option key={item.ITEM_CODE + '&' + index} value={item.ITEM_CODE + '&' + index}>
													{item.ITEM_NAME}
												</Option>
											))}
										</Select>
										<Button className="loadButton" loading={this.state.isLoading} onClick={this.searchData.bind(this)}>查询</Button>
										<Button className="loadButton" loading={this.state.isExportLoading} onClick={this.exportPackageData}>导出</Button>
										<Button className="rightButton" onClick={this.turnInstitutionOrPerson}>{institutionOrPerson === 0 ? '转入个人会诊量表' : '转入机构会诊量表'}</Button>
									</div>
								</div>
							</div>
							<div className="statisticsTableBox" id="packageStatisticsTableBox">
								<Spin size="large" spinning={this.state.isLoading} tip="Loading...">
									<Table
										columns={packageColumns}
										dataSource={institutionOrPerson === 0 ? packageHospitalData : packagePersonData}
										bordered
										pagination={false}
										rowClassName={this.state.isFixedHeJiTaoCan ? fixedTotal : () => { }}
										scroll={{
											x: 1200,
											y: 500
										}}
										rowKey={(record, index) =>
											index
										} // 需要修改为唯一的ID！
										title={() => (
											<div className="tableHeader">
												<p>{institutionOrPerson === 0 ? '会诊机构：' : '申请机构：'}{institutionOrPerson === 0 ? this.state.consultHospitalName : this.state.applyHospitalName}</p>
												<p>
													查询时间：{searchTime}
												</p>
											</div>
										)}
									></Table>
								</Spin>
							</div>
						</TabPane>
					</Tabs>
				</div>

				{paintModalShow ? (
					<Modal
						zIndex={-9}
						visible={paintModalShow}
						width="100%"
						footer={false}
						style={{ top: "-50px", padding: "0" }}
						className="paintmodal"
						onCancel={this.handleCloseApplyModal}>
						<PaintStatisticsTable
							showKey={showKey}
							dataList={
								showKey === "1"
									? dataList
									: showKey === "2"
										? doctorWorkList
										: billDoctorWorkList
							}
							consultHospitalName={this.state.consultHospitalName}
							applyHospitalName={this.state.applyHospitalName}
							selectStartValue={this.state.selectStartValue}
							selectConsultationMonth={this.state.selectConsultationMonth}
							selectBillDoctorName={this.state.selectBillDoctorName}
							billHospitalCode={this.state.billHospitalCode}
							selectdoctorName={this.state.selectdoctorName}
							closeModal={() => {
								this.setState({ paintModalShow: false });
							}}
							selectEndValue={this.state.selectEndValue}
							selectDoctorMonth={this.state.selectDoctorMonth}
							billHospitalName={this.state.billHospitalName}
							selectBillMonth={this.state.selectBillMonth}
						/>
					</Modal>
				) : null}

				<Drawer
					placement='right'
					width={800}
					closable={false}
					onClose={this.onClose}
					visible={this.state.drawerShow}
				>
					<Divider orientation="left">医疗机构</Divider>
					<div className="drawerStyle">
						<div className="childStyle">
							<span>联系人：</span>
							<Input readOnly value={this.state.rightClickRecord.MEDICAL_CONTACT} style={{ width: '150px' }} />
						</div>
						<div className="childStyle">
							<span>联系电话：</span>
							<Input readOnly value={this.state.rightClickRecord.MEDICAL_TEL} style={{ width: '150px' }} />
						</div>
					</div>
					<Divider orientation="left">经销商</Divider>
					<div className="drawerStyle">
						<div className="childStyle">
							<span>联系人：</span>
							<Input readOnly value={this.state.rightClickRecord.DEALER_CONTACT} style={{ width: '150px' }} />
						</div>
						<div className="childStyle">
							<span>联系电话：</span>
							<Input readOnly value={this.state.rightClickRecord.DEALER_TEL} style={{ width: '150px' }} />
						</div>
					</div>
					<Divider orientation="left">安装时间</Divider>
					<div className="drawerStyle">
						<div className="sisterStyle">
							<span>静息心电：</span>
							<Input readOnly value={this.state.rightClickRecord.ECG_INSTALL_DATE ? moment(this.state.rightClickRecord.ECG_INSTALL_DATE).format('YYYY-MM-DD') : ''} style={{ width: '120px' }} />
						</div>
						<div className="sisterStyle">
							<span>动态心电：</span>
							<Input readOnly value={this.state.rightClickRecord.HOLTER_INSTALL_DATE ? moment(this.state.rightClickRecord.HOLTER_INSTALL_DATE).format('YYYY-MM-DD') : ''} style={{ width: '120px' }} />
						</div>
						<div className="sisterStyle">
							<span>动态血压：</span>
							<Input readOnly value={this.state.rightClickRecord.BP_INSTALL_DATE ? moment(this.state.rightClickRecord.BP_INSTALL_DATE).format('YYYY-MM-DD') : ''} style={{ width: '120px' }} />
						</div>
					</div>
					<Divider orientation="left">撤机时间</Divider>
					<div className="drawerStyle">
						<div className="sisterStyle">
							<span>静息心电：</span>
							<Input readOnly value={this.state.rightClickRecord.ECG_WITHDRAWAL_DATE ? moment(this.state.rightClickRecord.ECG_WITHDRAWAL_DATE).format('YYYY-MM-DD') : ''} style={{ width: '120px' }} />
						</div>
						<div className="sisterStyle">
							<span>动态心电：</span>
							<Input readOnly value={this.state.rightClickRecord.HOLTER_WITHDRAWAL_DATE ? moment(this.state.rightClickRecord.HOLTER_WITHDRAWAL_DATE).format('YYYY-MM-DD') : ''} style={{ width: '120px' }} />
						</div>
						<div className="sisterStyle">
							<span>动态血压：</span>
							<Input readOnly value={this.state.rightClickRecord.BP_WITHDRAWAL_DATE ? moment(this.state.rightClickRecord.BP_WITHDRAWAL_DATE).format('YYYY-MM-DD') : ''} style={{ width: '120px' }} />
						</div>
					</div>
					<Divider orientation="left">移机时间</Divider>
					<div className="drawerStyle">
						<div className="sisterStyle">
							<span>静息心电：</span>
							<Input readOnly value={this.state.rightClickRecord.ECG_RELOCATION_DATE ? moment(this.state.rightClickRecord.ECG_RELOCATION_DATE).format('YYYY-MM-DD') : ''} style={{ width: '120px' }} />
						</div>
						<div className="bigStyle">
							<span>移至地点：</span>
							<Tooltip title={this.state.rightClickRecord.ECG_RELOCATION_PLACE}>
								<Input readOnly value={this.state.rightClickRecord.ECG_RELOCATION_PLACE} style={{ width: '370px' }} />
							</Tooltip>
						</div>
					</div>
					<div className="drawerStyle">
						<div className="sisterStyle">
							<span>动态心电：</span>
							<Input readOnly value={this.state.rightClickRecord.BP_RELOCATION_DATE ? moment(this.state.rightClickRecord.BP_RELOCATION_DATE).format('YYYY-MM-DD') : ''} style={{ width: '120px' }} />
						</div>
						<div className="bigStyle">
							<span>移至地点：</span>
							<Tooltip title={this.state.rightClickRecord.BP_RELOCATION_PLACE}>
								<Input readOnly value={this.state.rightClickRecord.BP_RELOCATION_PLACE} style={{ width: '370px' }} />
							</Tooltip>
						</div>
					</div>
					<div className="drawerStyle">
						<div className="sisterStyle">
							<span>动态血压：</span>
							<Input readOnly value={this.state.rightClickRecord.HOLTER_RELOCATION_DATE ? moment(this.state.rightClickRecord.HOLTER_RELOCATION_DATE).format('YYYY-MM-DD') : ''} style={{ width: '120px' }} />
						</div>
						<div className="bigStyle">
							<span>移至地点：</span>
							<Tooltip title={this.state.rightClickRecord.HOLTER_RELOCATION_PLACE}>
								<Input readOnly value={this.state.rightClickRecord.HOLTER_RELOCATION_PLACE} style={{ width: '370px' }} />
							</Tooltip>
						</div>
					</div>
				</Drawer>
			</div>
		);
	}
}

export default Form.create()(StatisticsTable);
